var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderSplashBlack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "22.5423cm",
    height: "24.9705cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 23532.77 26067.7",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conte\\xFAdo_x0020_do_x0020_PowerClip"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2608632148496"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M22650.52 494.98c14.19,31.86 34.8,33.95 57.09,29.29 19.87,-22.91 19.81,-52.87 5.1,-88.03 -16.95,-4.88 -48.01,35.78 -62.2,58.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M23295.12 131.33c38.18,18.03 120.67,-67.43 85.35,-131.33 -38.23,7.84 -96.19,77.17 -85.35,131.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M21077.41 2450.16c24.57,39.48 93.54,7.84 114.73,-40.04 -27.53,-102.25 -106.68,-9.13 -114.73,40.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19663.45 4066.82c14.16,31.93 28.29,63.9 42.47,95.88 122.58,19.62 280.82,-200.77 420.46,-371.4 53.51,-65.4 100.08,-146.61 103.62,-214.58 -102.56,-61.37 -185.88,89.94 -260.8,158.71 -120.82,111.09 -256.76,184.86 -305.75,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M21927.49 4816.72c9.2,45.14 -10.85,79.86 -25.64,116.56 64.96,-1.02 140.27,-145.34 181.13,-214.04 -42.76,-27.06 -79.58,63.61 -155.49,97.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M21613.96 5279.93c100.02,78.13 190.47,-117.65 207.34,-204.7 -100.72,43.86 -209.85,65.92 -207.34,204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20585.78 6521.89c32.73,-12.32 30.13,-37.25 40.83,-57.34 -19.21,-33.44 -77.56,17.92 -40.83,57.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20651.4 6769.59c63.05,51 113.06,-76.04 93.7,-137.27 -50.42,6.04 -69.22,92.8 -93.7,137.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18057.88 11378.76c228.31,252.17 355.05,-134.73 512.08,-338.8 89.79,-116.48 209.85,-206.52 323.6,-315.96 153.31,-147.72 397.13,-414.08 485.79,-572.72 76.41,-136.57 207.74,-447.44 96.02,-630.28 -104.44,-171.14 -452.98,-20.9 -583.48,53.2 -310.46,176.28 -380.63,480.02 -465.28,768.5 -41.67,142.17 -109.54,254.73 -148.55,387.2 -191.46,168.1 -295.49,407.32 -220.18,648.86zm730.04 -1266.89c-6.35,-14.19 -12.6,-28.45 -18.85,-42.56 7.43,-30.36 18.28,-59.33 52.84,-80.19 52.43,33.99 22.47,129.24 -33.99,122.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M23138.67 425.91c11.7,13.21 9.02,-5.61 3.66,-16.76 -104.35,138.55 -250.65,286.68 -352.76,449.31 25.46,25.85 29.53,-51.81 51.27,-8.69 10.01,15.5 0.23,24.08 5.83,38.01 -26.2,33.67 -30.96,-30.46 -56.11,-1.9 67.88,52.98 -36.67,100.86 -1.9,169.86 183.52,-205.75 261.52,-400.17 350.01,-629.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M23532.77 2585.74c-371.99,327.04 -639.44,810.95 -809.62,1211.64 292,-325.82 621.91,-789.39 809.62,-1211.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M22661.91 3883.5c-107.06,27.09 -192.49,203 -250.7,305.92 -178.6,160.95 -208.56,367.22 -350.76,503.9 211.84,-139.72 460.73,-532.39 601.47,-809.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M21219.8 5885.12c-85.69,7.66 -67.7,128.36 -131.94,150.65 7.27,10.08 19.9,-4.66 26.24,9.35 -28.57,14.36 -78.32,73.03 -76.91,125.2 62.28,-70.17 131.25,-172.87 182.61,-285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13051.16 85.05c-31.66,-8.1 -32.73,40.66 -18.31,58.04 7.38,-6.13 14.79,-12.1 27.42,-11.66 1.15,-20.78 -11.19,-24.42 -9.11,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5877.8 375.2c-31.57,-8.17 -32.73,40.66 -18.31,57.97 31.66,8.17 32.76,-40.66 18.31,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11618.28 885.81c-1.16,28.56 -1.33,55.94 9.1,69.55 23.45,-1.1 13.01,-45.24 36.51,-46.41 -1.36,-25.37 -22.98,-24.82 -45.61,-23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13115.03 1164.31c-22.73,-1.91 -28.23,18.26 -45.67,23.13 1.1,33.47 -5.02,76 9.11,92.9 22.19,-29.73 54.52,-68.89 36.56,-116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11152.85 1187.41c-12.2,0 -24.4,0 -36.59,0 1.84,211.18 -134.43,246.74 -118.57,475.78 152.82,-22.62 133.35,-324.99 155.16,-475.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3285.84 1558.84c-7.02,78.53 25.63,106.68 82.17,104.34 44.26,-79.63 -35,-175.11 -82.17,-104.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13142.42 1570.39c-9.18,0 -18.28,0 -27.39,0 4.93,16.86 -10.7,59.97 9.11,58.07 30.65,11.88 14.18,-36.12 18.28,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6471.05 1674.84c-29.32,-3.26 -33.27,50.86 -18.31,69.7 34.49,9.87 32.33,-52.06 18.31,-69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13899.88 1895.41c26.33,-116.92 -42.06,-192.3 -91.25,-127.74 -59.2,77.69 21.7,234.82 91.25,127.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7027.69 2162.2c-9.11,0 -18.2,0 -27.39,0 0,15.51 0,31.03 0,46.42 13.34,-10.13 35.4,-9.17 27.39,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6826.92 2556.73c-9.11,0 -18.28,0 -27.39,0 -2.34,37.95 10.84,55.87 36.48,58.12 2.94,-26.99 -1.41,-44.51 -9.08,-58.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16656.08 2626.4c-1.82,33.25 -1.15,63.39 27.39,58.07 -1.15,-20.78 11.19,-24.53 9.11,-46.41 -8.18,-8.99 -20.65,-12.51 -36.51,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11536.13 3009.42c-16.03,2.75 -20.8,19.94 -18.23,46.41 9.11,0 18.23,0 27.39,0 3.83,-24.24 -6.35,-30.72 -9.17,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3879.11 3195.11c-1.84,56.5 4.01,103.2 54.79,92.8 5.07,-60.72 2.08,-110.95 -54.79,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15013.26 3345.98c4.01,33.76 41.24,60.19 63.87,34.83 1.36,-39.7 -49.91,-85.35 -63.87,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11846.44 3462.02c-17.21,16.8 -40.42,25.92 -36.48,69.66 49.86,11.37 64.01,-45.87 36.48,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7949.47 3519.99c-7.27,6.19 -14.79,12.1 -27.39,11.69 -9.34,46.6 14.27,51.48 27.39,69.55 33.22,-7.77 14.84,-67.53 0,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5959.95 3636.06c-4.15,36.33 19.55,37.17 45.59,34.83 0,-11.69 0,-23.18 0,-34.83 -11.91,-14.89 -33.56,-14.89 -45.59,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11189.35 3659.2c-26.64,12.54 -47.77,32.04 -45.7,81.31 16.61,29.12 56.46,29.12 73.07,0 9.29,-50.52 -18.94,-53.38 -27.36,-81.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18207.5 3728.85c-35.64,1.06 -61.79,14.23 -54.67,69.66 5.56,16.14 35.03,1.8 36.48,23.25 23.71,-8.69 37.31,-65.18 18.2,-92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9254.53 3844.89c15.2,0 30.39,0 45.59,0 51.21,-134.96 -115.14,-111.49 -45.59,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11326.2 3833.35c24.3,-4.04 30.82,-30.5 36.5,-58.12 -19.54,-27.57 -65.31,24.2 -36.5,58.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11134.56 3856.59c-37.07,-10.92 -31.65,62.85 -18.3,81.21 37.16,10.86 31.65,-62.83 18.3,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9902.53 4007.31c-107.81,15.51 -43.91,251.95 27.39,301.77 171.85,26.4 166.08,-323.99 -27.39,-301.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11070.67 4007.31c-9.08,0 -18.2,0 -27.36,0 -3.84,24.34 6.25,30.8 9.17,46.53 16.03,-2.79 20.82,-19.98 18.2,-46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16418.78 4088.66c-23.79,-3.18 -45.67,-3.93 -36.48,34.76 23.87,3.37 39.24,-4.19 36.48,-34.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15122.82 4100.21c-28.05,-8.72 -17.56,31.86 -45.69,23.18 -21.54,147.24 -206.22,146.91 -164.24,336.57 155.47,-3.4 129.58,-237.54 228.23,-313.36 6.57,-31.6 -18.2,-23.35 -18.29,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10395.36 4355.46c-11.77,-240.91 -143.27,90.89 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13352.27 4367.13c-46.02,7.44 -98.78,76.26 -54.72,127.66 19.72,-40.59 57.24,-58.85 54.72,-127.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10851.69 4367.13c-54.47,15.84 -61.82,91.66 -63.9,174.15 36.07,-37.47 78.25,-109.04 63.9,-174.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11472.23 4378.71c-12.37,34.2 -11.44,71.9 9.17,92.9 8.11,-9.02 20.57,-12.54 36.51,-11.66 4.01,-51.62 -5.16,-86.34 -45.67,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18198.41 4494.79c-40.16,-4.58 -61.82,14.19 -63.89,58.03 32.32,32.59 70.4,-4.95 63.89,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4508.79 4494.79c-14.04,16.86 -8.05,59.32 -9.11,92.9 58.68,17.6 76.99,-19.25 118.65,-23.28 -19.81,-44.47 -49.02,-76.99 -109.54,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6060.32 4692.03c1.1,33.48 -4.99,75.93 9.1,92.8 75.49,10.3 81.83,-120.8 -9.1,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14766.88 4738.44c-23.19,1.47 -35.41,16.87 -36.48,46.38 12.19,0 24.39,0 36.48,0 0,-15.4 0,-30.91 0,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11234.94 4738.44c-13.35,16.87 -13.35,76.01 0,92.91 29.13,9.85 28.23,-18.4 45.67,-23.28 -1.85,-40.22 -7.61,-75.38 -45.67,-69.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6124.21 4796.52c-4.5,59.87 9.34,96.39 54.75,92.8 7.87,-9.34 5.45,-31.75 18.2,-34.83 -9.25,-36.12 -41.55,-86.53 -72.95,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10495.73 4819.77c0,15.4 0,30.91 0,46.27 23.96,3.34 39.29,-4.22 36.5,-34.68 -8.12,-9.06 -20.56,-12.58 -36.5,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14164.57 4854.49c-14.67,27.82 -30.04,54.7 -27.36,104.45 8.08,5.1 16.26,10.23 18.2,23.29 87.34,21.63 112.98,-152.2 9.17,-127.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7493.2 4877.73c-23.21,1.18 -21.63,43.23 -9.2,58 19.15,4.95 24.16,-7.88 36.51,-11.58 8.01,-37.29 -23.65,-24.13 -27.31,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16236.27 4900.86c-35.93,-6.96 -47.37,17.09 -63.9,34.87 -2.94,26.95 1.5,44.54 9.08,58.04 42.27,-0.51 59.32,-33 54.82,-92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8989.84 4900.86c-9.11,0 -18.2,0 -27.31,0 -26.9,194.54 -109.79,378.41 -91.28,591.97 65.97,-156.3 105.16,-407.4 118.59,-591.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9555.76 4935.73c-38.09,7.85 -4.24,72.08 18.22,34.79 -3.29,-15.18 -16.06,-18.26 -18.22,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16172.34 5098.26c-15.19,0 -30.39,0 -45.58,0 -6.69,46.09 -6.69,46.6 0,92.8 52.16,3.18 55.59,-44.91 45.58,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12676.93 5167.81c-34.66,0.33 -33.25,60.5 9.2,46.38 3.83,-24.2 -6.25,-30.69 -9.2,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9993.8 5202.6c1.01,60.68 14.62,105.23 36.51,139.32 21.31,0 42.58,0 63.86,0 30.57,-44.81 25.98,-109.14 0,-162.53 -46.1,-10.52 -70.99,-9.46 -100.36,23.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16875.13 5179.39c-12.19,0 -24.3,0 -36.51,0 -8.18,54 48.36,59.55 36.51,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6178.97 5283.85c-29.64,53.52 10.44,96.61 9.11,150.87 -2.83,115.93 -102.13,382.98 18.28,382.98 61.04,0 70.82,-135.06 54.79,-243.77 -11.45,-77.29 -52.85,-175.21 -45.67,-290.08 -12.19,0 -24.3,0 -36.51,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13817.79 5527.51c118.74,-310.53 -254.12,-38.09 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8077.29 5388.3c-33.22,80.74 -0.32,126.89 45.58,162.5 88.53,-22.4 50.35,-224.49 -45.58,-162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15186.69 5399.89c-29.12,44.22 -61.47,84.33 -54.75,174.05 13.09,6.6 22.29,18.14 27.36,34.94 136.62,60.27 190.31,-253.17 27.39,-208.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14237.58 5446.41c-21.22,57.01 -48.27,95.14 -18.2,162.46 124.24,62.95 160.98,-219.39 18.2,-162.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11308 5829.29c34.97,-5.72 52.1,-34.28 72.97,-57.97 2.78,-227.6 -189.37,-49.57 -72.97,57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15852.95 5748.08c-60.96,11.55 -94.7,57.63 -109.54,127.58 44.23,10.86 115.97,-36 109.54,-127.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12622.24 5748.08c-42.02,58.81 -109.95,84.58 -109.54,197.24 20.03,13.16 37.25,29.95 73.07,23.25 7,-74.43 71.91,-129.94 36.48,-220.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13845.18 5806.08c3.66,28.01 -16.72,25.22 -9.2,58.03 8.1,5.21 16.37,10.19 18.22,23.28 22.78,1.8 28.29,-18.29 45.64,-23.28 2.86,-46.08 -17.53,-62.73 -54.66,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8953.33 5910.53c-0.49,38.02 -25.94,44.4 -18.25,92.91 -214.29,-109.89 -201.52,283.81 -36.51,266.94 61.48,-6.38 93.86,-75.74 82.15,-162.56 18.14,-11.81 41.76,-4.98 82.1,-11.58 43.76,-89.83 -5.43,-211.85 -109.49,-185.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14055.04 6014.99c7.76,-2.09 8.59,4.58 9.2,11.59 125.57,4.69 -12.81,-171.22 -9.2,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1862.13 5991.85c-32.64,-6.79 -27.74,34.31 -27.31,69.55 15.2,0 30.39,0 45.59,0 9.77,-31.53 5.76,-54.34 -18.28,-69.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9866.06 6200.72c-5.04,60.49 3.98,103.09 54.75,92.8 41.09,-43.23 -1.75,-140.71 -54.75,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15150.19 6432.8c63.23,1.8 131.45,-66.26 127.79,-185.71 -83.36,-106.58 -212.01,78.68 -127.79,185.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17532.16 6235.55c-75,51.51 -158.42,92.46 -182.54,208.83 100.28,-0.22 126.58,-94.36 191.74,-139.31 1.15,-28.56 1.29,-55.84 -9.2,-69.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14985.98 6374.76c216.86,-126.16 -145.3,-175.1 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9163.27 6270.37c-12.19,0 -24.27,0 -36.5,0 1.1,29.41 13.29,45.03 36.5,46.28 0,-15.4 0,-30.91 0,-46.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11627.42 6467.63c26.9,14.77 57.55,-3.81 91.26,-11.69 56.28,-197.47 -179.09,-163.04 -91.26,11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16765.65 6421.14c10.61,-1.91 16.2,2.53 18.2,11.66 36.64,-11.48 55.93,-44.92 54.78,-104.46 -46.94,-44.29 -107.89,33.15 -72.97,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7301.48 6560.45c-16.29,-1.5 -19.2,14.2 -36.46,11.56 3.16,26.94 5.91,54.48 36.46,46.41 17.1,-22.11 -5.42,-20.93 0,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13972.89 6618.42c-23.82,-3.19 -39.24,4.22 -36.51,34.79 17.1,22.84 44,6.82 36.51,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9637.81 6664.81c-28.85,66.25 -19.52,127.84 9.23,174.11 143.19,17.97 79.99,-210.55 -9.23,-174.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3477.58 6688.04c-34.17,-9.46 -16.9,71.57 -9.14,81.25 26.59,-0.22 21.54,-65.52 9.14,-81.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3870.01 6757.71c-12.2,0 -24.37,0 -36.48,0 -0.18,20.9 0.74,126.56 54.66,116.03 7.93,-56.35 -26.12,-59.68 -18.19,-116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12540.06 6954.95c32.89,19.54 65.13,-12.64 91.28,-34.83 28.32,-220.08 -194.54,-87.48 -91.28,34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11581.74 6827.3c-34.66,0.32 -33.16,60.45 9.18,46.41 3.83,-24.2 -6.26,-30.8 -9.18,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19348.29 6897.03c-45.67,-61.71 -138.77,-15.63 -136.84,46.27 2.91,92.71 129.81,52.57 136.84,-46.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9628.73 6897.03c-18.68,11.03 -43.39,14.33 -45.58,46.27 -3.84,39.82 27.3,34.94 36.48,58.07 31.13,-12.21 35.35,-82.17 9.1,-104.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9354.93 7210.2c13.27,6.35 47.21,-13.49 45.67,11.66 166.86,-183.24 -167.06,-233.92 -45.67,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14593.44 7082.54c-9.08,0 -18.2,0 -27.3,0 -3.84,24.34 6.25,30.8 9.1,46.53 16.12,-2.86 20.8,-20.05 18.2,-46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10331.49 7094.13c1.65,32.71 15.86,49.49 45.65,46.53 5.27,-43.01 -24.6,-71.9 -45.65,-46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13178.84 7094.13c-44.26,-5.39 -51.76,48.54 -27.31,69.66 19.62,-9.87 32.33,-28.56 27.31,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15980.71 7129.07c-27.05,8.17 -43.25,30.07 -45.67,69.55 44.49,10.08 57.52,-19.76 63.87,-57.96 -10.52,1.87 -16.2,-2.57 -18.2,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14118.93 7210.2c-15.63,14.96 -35.84,24.08 -36.51,58.03 29.42,40.15 61.79,-28.62 36.51,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11791.74 7245.03c-15.2,0 -30.48,0 -45.67,0 -1.76,70.07 -62.36,118.28 -36.51,185.71 66.47,-12.1 61.97,-114.61 82.18,-185.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11545.3 7268.24c-20.04,35.39 -26.07,114.47 -9.17,162.5 161.15,140.12 166.31,-257.6 9.17,-162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7274.19 7268.24c-25.46,80.4 21.11,139.66 82.06,104.53 19.11,-56.21 -17.62,-154.71 -82.06,-104.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2729.24 7372.77c8.36,47.33 28.86,79.31 82.09,69.62 7.76,-70.72 -43.19,-92.68 -82.09,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13260.98 7372.77c-21.11,-3.74 -35.07,1.8 -45.59,11.55 0,15.51 0,30.91 0,46.42 10.78,13.34 32.24,13.12 54.79,11.65 1.18,-28.67 1.33,-55.94 -9.2,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9765.6 7395.97c-11.93,11.81 -33.55,11.4 -45.58,23.18 0.05,30.75 -3.43,66.25 9.08,81.21 32.06,-10.42 30.04,2.23 54.79,-23.25 5.91,-42.27 -6.12,-61.81 -18.29,-81.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12111.13 7616.43c123.41,-70.61 3.75,-269.91 -54.78,-139.32 -19.44,43.41 -1.99,131.04 54.78,139.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4280.66 7477.11c-11.1,113.62 77.21,152.67 127.74,92.91 11.3,-68.82 -66.29,-154.58 -127.74,-92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7009.46 7488.69c-33.65,18.48 -62.14,143.31 -27.39,174.12 52.28,-3.08 17.13,-117.43 27.39,-174.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10979.41 7546.88c-4.09,55.43 9.95,87.81 36.51,104.34 104.21,1.06 36.33,-203.41 -36.51,-104.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11335.3 7535.18c-7.35,6.16 -14.78,12.1 -27.3,11.7 0.41,178.98 -129.44,252.38 -91.29,440.84 131.19,-47.15 120.53,-319.52 118.59,-452.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7967.72 7570.02c-31.98,9.12 -10.49,40.55 0,57.96 12.29,-7.66 16.98,-24.74 18.31,-46.38 -10.61,1.91 -16.3,-2.56 -18.31,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13142.42 7593.15c-42.68,-11.56 -51.04,20.27 -45.67,69.66 34.05,4.69 53.51,-9.24 54.78,-46.38 -8.94,-0.33 -7.09,-14.26 -9.1,-23.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7383.66 7662.81c-6.78,97.67 33.79,134.95 109.54,127.62 98.61,-102.44 -45.27,-257.82 -109.54,-127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14064.23 7674.39c6.17,111.39 102.62,52.1 82.09,-23.17 -27.56,-33.55 -68.34,-19.32 -82.09,23.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9729.11 7627.98c-12.11,0 -24.28,0 -36.48,0 -10.62,40.22 51.01,53.97 36.48,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7666.63 7662.81c-8.76,41.83 39.34,20.6 45.59,11.58 4.35,-22.73 -41.84,-37.39 -45.59,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9720.02 7709.19c-35.49,12.98 -44.79,59.18 -45.62,116.08 15.23,0 30.42,0 45.62,0 7.92,-28.67 17.84,-89.94 0,-116.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1707.03 7918.17c-12.2,0 -24.33,0 -36.51,0 -14.12,16.86 -8.04,59.36 -9.11,92.79 12.94,-0.95 25.81,-1.9 27.39,11.66 33.91,-7.62 30.8,-68.99 18.23,-104.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10431.83 7941.31c-24.04,-3.52 -29.87,16.13 -27.28,46.41 23.79,3.3 39.24,-4.14 36.39,-34.72 -7.67,2.13 -8.51,-4.58 -9.11,-11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8205.05 7941.31c-12.03,4.14 -14.35,20.49 -27.39,23.24 -2.24,33.77 17.21,40.04 27.39,58.07 33.16,-7.84 14.79,-67.61 0,-81.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2236.38 7941.31c0,15.5 0,31.02 0,46.41 11.6,15.91 43.08,15.91 54.67,0 -8.77,-27.42 -15.92,-56.91 -54.67,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5330.29 7987.72c-16.03,10.6 -31.81,21.63 -27.48,58.07 19.2,25.48 40.59,2.42 54.78,-11.69 -2.68,-23.58 -24.62,-22.59 -27.3,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4143.78 7999.41c-3.17,89.57 57.72,125.02 109.48,81.18 17.87,-91.29 -60.87,-111.9 -109.48,-81.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17769.46 7999.41c-22.98,2.71 -37.8,34.17 -18.28,57.97 18.62,-8.4 37.31,-34.94 18.28,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7922.08 8034.1c-6.02,0 -12.11,0 -18.2,0 1.47,13.59 -2.01,20.71 -9.13,23.28 1.69,9.42 9.13,11.55 9.13,23.21 7.33,-6.13 14.76,-12.1 27.36,-11.66 0,-7.66 0,-15.4 0,-23.13 -7.76,2.13 -8.59,-4.55 -9.17,-11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14812.55 8057.38c-66.73,-21.48 -93.34,73.58 -54.75,116.03 42.64,3.93 53.77,-32.08 72.97,-58 -3.83,-22.07 -26.07,-21 -18.22,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6169.88 8080.59c-31.91,43 -29.72,195.27 27.28,197.28 28.67,5.43 24.17,-31.2 45.7,-34.79 -4.5,-79.31 -14.45,-151.86 -72.98,-162.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9364.04 8440.32c33.82,-15.06 30.88,-76.88 54.79,-104.49 -61.87,-337.19 -331.76,78.61 -54.79,104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8077.29 8208.24c-16.12,2.76 -20.88,19.95 -18.28,46.5 10.58,-1.91 16.2,2.45 18.28,11.55 16.02,-2.86 20.78,-20.02 18.22,-46.49 -10.61,1.94 -16.2,-2.54 -18.22,-11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12594.87 8301.15c-128.71,-68.82 -115.91,183.35 -27.38,185.59 58.52,1.46 111.21,-140.83 27.38,-185.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16172.34 8301.15c-40.83,-9.46 -50.68,20.57 -54.69,57.96 31.65,31.64 78.17,-15.91 54.69,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12302.78 8486.74c85.93,-220.87 -191.4,-40.15 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7118.97 8359.11c-32.66,-6.82 -27.77,34.4 -27.33,69.66 40.94,15.69 44.35,-46.71 27.33,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7529.71 8405.49c-66.41,-9.53 -151.17,48.32 -155.16,139.32 -6.08,138.1 182.52,260.74 273.8,139.21 52.1,-136.68 -9.59,-275.56 -118.64,-278.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6799.53 8405.49c-10.93,32.59 -5.25,74.03 36.48,69.66 24.56,-34.62 -5.3,-70.39 -36.48,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15186.69 8498.32c13.18,6.46 22.29,18.23 27.39,34.91 53.12,9.46 71.22,-25.48 91.26,-58.07 -10.59,-85.86 -125.08,-69.33 -118.65,23.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14730.4 8451.91c-28.57,-5.31 -40.78,10.08 -36.51,46.41 21.22,3.82 35.09,-1.83 45.67,-11.58 -4.84,-9.35 -9.51,-18.81 -9.17,-34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14264.97 8533.23c-250.02,-50.19 -236.41,421.95 -27.39,394.45 174.84,-22.95 240.87,-351.67 27.39,-394.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10477.39 8544.82c-83.3,-64.01 -127.74,161.72 -27.28,150.86 54.36,-5.93 80.68,-109.99 27.28,-150.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14648.31 8660.85c31.32,42.49 87.83,39.48 118.57,0 29.23,-160.74 -142.7,-138.55 -118.57,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13434.41 8660.85c-12.19,0 -24.27,0 -36.56,0 0,15.4 0,30.91 0,46.38 28.64,5.36 40.83,-10.08 36.56,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11253.22 8660.85c-28.72,-1.68 -31.31,29.73 -36.51,57.97 30.4,27.82 59.2,-22.91 36.51,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5394.06 8881.31c25.9,-152.05 -100.1,-219.36 -173.31,-139.21 -43.33,146.2 99.59,241.9 173.31,139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8743.43 8765.24c-21.45,99.72 12.94,183.27 72.98,185.73 136.12,5.65 51.12,-303.53 -72.98,-185.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5823.01 8776.93c-0.84,97.23 82.18,125.05 127.77,69.62 21.45,-130.7 -88.92,-134.73 -127.77,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18225.81 8765.24c-21.16,-3.71 -35,1.94 -45.61,11.73 0.84,34.49 54.35,30.97 45.61,-11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2409.82 8765.24c-14.79,-3.15 -15.81,11.07 -27.49,11.73 24.57,84.8 20.22,206.26 91.26,231.96 40.66,-115.52 -55.93,-151.6 -63.77,-243.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6662.68 8788.51c-34.56,-10.01 -32.32,51.92 -18.3,69.66 34.48,9.85 32.32,-52.03 18.3,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11700.45 8881.31c-53.02,-5.43 -69.45,35.56 -63.98,104.49 34.43,25.04 38.7,-18.19 73.07,-23.28 -0.05,-30.76 3.43,-66.14 -9.08,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12832.06 8892.97c-26.41,8.94 -44.35,28.7 -36.51,81.24 22.55,1.5 44.02,1.8 54.79,-11.69 5.16,-37.58 -2.77,-58.29 -18.28,-69.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8305.42 8950.96c-63.98,108.19 -82.18,336.46 -73.01,499.02 45.36,-132.32 81.77,-336.23 73.01,-499.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8405.75 8962.52c-12.11,0 -24.27,0 -36.5,0 -3.84,24.34 6.25,30.72 9.1,46.41 24.05,3.63 29.96,-16.02 27.39,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16427.94 9043.87c-3.05,42.46 10.13,64.45 18.23,92.8 25.63,13.89 62.94,12.72 100.43,11.55 20.13,-36.18 36.93,-76.74 45.53,-127.59 -48.18,-64.01 -130.41,-45.46 -164.18,23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18937.65 8985.8c-25.77,-9.57 -23.61,16.35 -45.64,11.69 -6.86,52.32 61.01,43.41 45.64,-11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6361.49 8985.8c-23.87,-3.19 -39.24,4.25 -36.57,34.83 17.1,22.81 44,6.67 36.57,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11116.26 9241.01c61.99,-14.96 123.09,-125.39 82.2,-197.14 -63.9,20.9 -146.64,117.76 -82.2,197.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11846.44 9403.57c34.75,-58.81 74.39,-72.92 82.18,-127.62 28.54,-200.22 -183.79,-310.57 -246.41,-127.74 -35.75,104.2 39.82,290.85 164.23,255.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2647.06 9113.42c5.17,32.05 9.69,65.08 45.62,58.07 27.28,-41.83 -17.16,-83.05 -45.62,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15725.18 9113.42c-12.19,0 -24.39,0 -36.59,0 -10.18,46.89 28.09,57.3 45.7,34.79 -4.88,-9.31 -9.51,-18.77 -9.11,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8716.03 9113.42c-2.68,30.58 12.72,38.14 36.59,34.79 2.75,-30.58 -12.72,-37.98 -36.59,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9464.5 9148.21c-169.91,-52.65 -132.86,316.44 18.28,278.64 108.04,-27.21 88.27,-245.61 -18.28,-278.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10942.94 9171.49c-127.93,14.52 -260.62,243.45 -127.76,348.05 83.15,-64.35 126.89,-178.81 127.76,-348.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1880.43 9194.63c-17.84,21.78 -2.82,42.57 0,69.66 12.11,0 24.31,0 36.51,0 7.67,-13.49 12.03,-31.02 9.2,-57.96 -22.06,4.66 -19.9,-21.27 -45.7,-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19631.18 9217.88c-46.77,-6.45 -124.65,27.31 -127.67,116.03 -6.17,177.86 230.32,133.09 228.13,-11.55 -0.75,-45.76 -24.37,-93.97 -100.46,-104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13343.16 9391.88c46.1,66.06 127.76,27.75 136.87,-34.69 20.01,-136.01 -178.63,-165.42 -136.87,34.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13644.35 9275.95c-77.73,42.68 -203.07,79.01 -164.32,232.01 107.86,-2.98 158.47,-137.71 164.32,-232.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12485.31 9299.12c-6.09,0 -12.19,0 -18.23,0 -71.79,59.55 -71.22,211.18 -146.01,266.91 -48.79,278.42 -257.11,354.02 -273.8,673.06 15.6,-0.55 23.61,8.69 27.39,23.25 180.17,-81.15 278.29,-312.82 273.77,-591.82 59.31,-94.3 167.44,-239.01 136.87,-371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8679.56 9299.12c-13.44,6.05 -22.95,17.2 -36.5,23.25 3.16,26.99 5.94,54.37 36.5,46.38 19.96,-24.31 -4.52,-33.11 0,-69.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15697.71 9357.19c-25.12,6.61 -51.09,12.21 -45.59,57.97 10.62,9.79 24.46,15.28 45.59,11.69 12.55,-14.96 12.55,-54.81 0,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15807.28 9368.75c-33.3,15.62 -61.56,37.73 -72.98,81.24 47.26,13.68 56.2,-21.34 82.15,-34.83 1.18,-20.78 -11.16,-24.42 -9.17,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17805.93 9449.99c-15.95,10.64 -31.63,21.56 -27.36,57.97 21.19,3.74 35.06,-1.91 45.67,-11.56 -4.76,-17.12 -13.55,-29.32 -18.31,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4855.66 9496.4c14.62,91.12 70.63,186.73 127.76,185.71 -22.11,-87.92 -55.28,-161.83 -127.76,-185.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18463.11 9531.19c-6.11,0 -12.19,0 -18.31,0 1.7,9.91 -3.49,10.93 -9.08,11.59 0,7.74 0,15.47 0,23.25 7.76,-2.13 8.59,4.58 9.08,11.55 6.12,0 12.2,0 18.31,0 -1.67,-9.87 3.49,-10.93 9.08,-11.55 0,-7.78 0,-15.51 0,-23.25 -7.76,2.13 -8.59,-4.54 -9.08,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2856.97 9577.54c0.51,65.12 34.48,87.74 54.69,127.74 83.36,-17.59 80.68,64.35 164.36,69.56 14.01,-123.34 -104.81,-310.44 -219.05,-197.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8734.34 9554.44c-0.43,184.02 -95.38,411.13 -36.51,557.03 102.31,-86.56 50.92,-368.43 109.57,-510.61 -0.18,-23.13 -24.97,-14.74 -18.31,-46.41 -18.28,0 -36.48,0 -54.75,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17815.05 9635.54c0,23.25 0,46.53 0,69.74 17.04,1.5 30.56,7.66 36.59,23.18 94.77,-14.01 42.06,-184.75 -36.59,-92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12631.34 9658.79c-87.01,12.43 -178.19,71.02 -155.12,185.7 97.78,41.61 150.28,-70.69 155.12,-185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10057.69 9740.04c-28.66,6.04 -50.94,20.35 -72.97,34.79 -16.3,84.65 10.44,117.65 72.97,127.62 43.25,-51.99 32.56,-105.3 0,-162.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14693.9 9774.83c-55.36,26.21 -121.91,38.46 -155.15,92.93 42.01,38.65 126.09,-40.87 155.15,-92.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14337.94 9832.94c-39.9,3.41 -69.22,20.27 -63.89,81.21 8.1,5.09 16.37,10.19 18.31,23.25 55.85,5.83 74.7,-66.14 45.58,-104.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13306.69 9856.18c-27.34,23.24 -57.03,43.41 -54.79,104.34 18.95,-30.58 75.54,-60.5 54.79,-104.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11956.01 9972.11c16.43,-17.72 27.39,-42.46 36.48,-69.66 -45.1,-130.6 -153.66,57.11 -36.48,69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4819.09 9890.91c-13.72,145.59 137.77,157.54 146.05,58.07 6.51,-78.17 -85.86,-135.15 -146.05,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14529.66 9879.32c-6.12,0 -12.2,0 -18.31,0 -79.15,34.72 -96.02,148.63 -155.13,208.87 -80.09,56.79 -161.99,111.26 -173.43,255.32 122.75,12.54 166.39,-154.61 228.22,-255.32 43.66,-71.28 116.89,-112.89 118.65,-208.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9400.6 9879.32c-21.68,6.38 -37.92,44.91 -18.28,69.66 19.38,-9.35 35.59,-47.78 18.28,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18645.68 10006.94c-7.87,43.85 40.83,41.1 54.67,23.25 0,-11.7 0,-23.25 0,-34.84 -14.71,-19.72 -47,-10.6 -54.67,11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14748.68 10134.56c12.11,0 24.3,0 36.51,0 7.15,-44.58 -43.77,-44.58 -36.51,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9135.89 10111.43c-19.73,67.53 57.87,80.48 45.67,11.59 -10.59,-9.79 -24.46,-15.29 -45.67,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7401.92 10169.4c-3.66,63.35 61.87,93.45 91.28,46.49 0.49,-81.1 -55.36,-95.88 -91.28,-46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13516.59 10157.91c-81.59,31.64 -122.65,114.69 -191.63,162.34 75.23,60.72 131.24,-93.23 200.71,-116.07 1.18,-20.8 -11.16,-24.39 -9.08,-46.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6060.32 10215.88c39.82,116.92 55.04,420.45 182.54,313.21 9.34,-105.11 -53.46,-155.53 -82.18,-220.39 -24.97,-56.64 -9.51,-128.79 -54.75,-139.31 -18.13,11.77 -38.93,20.05 -45.61,46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20845.07 10239.05c24.31,18.59 63.56,8.18 82.18,-34.86 -6.69,-32.38 -90.2,-40.22 -82.18,34.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7246.71 10413.05c33.99,-181 -124.33,-281.46 -191.64,-174 0.06,0 -18.19,77.8 -18.19,81.21 0,125.5 125.3,219.25 209.82,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8150.26 10413.05c25.32,102.15 184.71,108.31 155.16,-46.3 -17.36,-90.85 -157.98,-117.94 -155.16,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3550.62 10401.48c-9.2,0 -18.36,0 -27.45,0 -7.7,114.34 8.07,198.67 54.75,243.8 15.19,0 30.39,0 45.58,0 44,-123.7 -58.59,-156.22 -72.89,-243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8807.41 10424.76c-7.7,25.15 -23.73,39.48 -18.31,81.21 63.29,108.3 145.87,-101.48 18.31,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15077.13 10552.38c-26.7,20.17 -70.79,18.26 -63.87,81.21 39.16,40.47 95.7,-31.53 63.87,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11234.94 10552.38c-40.08,-14.77 -58.04,29.29 -36.48,58.07 26.18,-1.5 43.33,-14.55 36.48,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10048.58 10784.46c21.8,-34.17 24.04,-93.23 45.58,-127.62 -77.9,-284.88 -321.81,150.13 -45.58,127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9254.53 10564.04c-7.32,6.04 -14.76,12.1 -27.36,11.59 -6.69,31.63 18.11,23.24 18.25,46.37 23.25,-1.17 21.57,-43.22 9.11,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11143.64 10633.59c-29.38,32.2 -81.97,34.9 -72.97,116.08 8.18,5.06 16.38,10.16 18.31,23.21 62.86,0.77 106.53,-94.59 54.66,-139.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16610.44 10668.41c0,19.44 0,38.76 0,58.07 27.36,33.88 73.79,16.02 100.34,-11.65 12.86,-83.48 -70.38,-82.42 -100.34,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18481.33 10668.41c-23.87,-3.26 -39.24,4.26 -36.51,34.84 23.91,3.18 45.7,3.93 36.51,-34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7474.89 10668.41c-2.57,30.36 3.37,49.9 27.42,46.42 2.47,-30.36 -3.37,-49.94 -27.42,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9291.04 10691.54c-9.11,0 -18.28,0 -27.31,0 -28.49,59.36 -29.23,171.26 -9.2,232.22 90.02,-18.29 54.87,-147.78 36.51,-232.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6744.82 10772.87c-25.45,51 -90.99,105.77 -54.75,197.28 88.32,29 67.62,-135.36 54.75,-197.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6553.12 10796.04c-19.64,9.85 -32.32,28.67 -27.39,69.62 12.19,0 24.4,0 36.51,0 1.23,-28.52 1.41,-55.94 -9.11,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15496.97 10807.69c1.18,20.83 -11.1,24.46 -9.08,46.42 26.3,21.27 28.54,18.77 63.87,11.55 0,-15.51 0,-30.87 0,-46.38 -10.78,-13.38 -32.21,-13.16 -54.79,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8095.51 10900.53c0.58,52.13 -31.83,77.58 -36.5,150.87 41.92,74.31 90.02,140.74 182.54,150.87 62.77,-51.62 98.92,-137.16 173.4,-174.15 7.93,-79.72 -22.29,-110.95 -54.87,-139.18 -42.73,-11.88 -51.81,19.1 -72.86,34.83 -66.58,-60.82 -130.44,-18.99 -191.72,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5448.85 10877.4c-67.65,-12.98 -50.43,119.41 -18.28,139.14 7.33,-6.13 14.88,-12.1 27.39,-11.56 27.71,-43.73 -10.44,-81.21 -9.11,-127.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15022.46 10912.08c-71.56,-5.83 -107.23,33.88 -155.15,58.07 -5.02,46.31 -5.02,34.94 0,81.25 59.19,-24.97 42.32,46.71 91.25,34.83 10.13,-36.4 4.27,-30.72 -9.17,-58.11 41.92,-16.32 78.22,-39.82 73.07,-116.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14411.01 11132.61c34.14,-342.73 -313.82,9.12 -118.64,69.66 46.56,14.41 84.16,-41 118.64,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11727.84 10993.33c-34.74,-10.08 -42.91,38.49 -27.39,58.07 25.64,1.68 26.3,-28.49 27.39,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13543.99 11039.74c-7.87,9.39 -5.42,31.82 -18.31,34.9 2.11,39.82 27.16,50.53 54.82,57.97 30.04,-40.25 38.2,-106.4 -36.51,-92.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10632.64 11039.74c-16.1,2.82 -20.85,20.01 -18.28,46.49 9.2,0 18.28,0 27.38,0 3.93,-24.3 -6.28,-30.8 -9.1,-46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5403.17 11051.4c-12.11,0 -24.3,0 -36.39,0 -21.96,77.72 -47.2,191.3 27.28,220.38 72.57,-19.09 24.54,-171.98 9.11,-220.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4910.35 11097.77c-38.15,-2.31 -33.65,91.95 -9.11,104.5 9.11,0 18.31,0 27.39,0 24.92,-37.51 -1.59,-83.89 -18.28,-104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10897.26 11132.61c-6.2,38.86 15.35,42.38 36.56,46.41 4.84,-9.35 9.52,-18.81 9.11,-34.83 -10.61,-9.69 -24.48,-15.29 -45.67,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5795.72 11155.85c-9.17,0 -18.37,0 -27.39,0 -13.44,16.8 -13.44,75.94 0,92.8 41.01,-7.22 31.66,-52.87 27.39,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6899.89 11237.1c-48.49,26.33 -95.34,128.47 -54.78,197.24 102.47,7.15 81.59,-122.31 54.78,-197.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3952.18 11237.1c-14.79,-3.3 -15.77,10.93 -27.48,11.55 5.19,55.33 34.84,79.53 54.79,116.08 47.49,-35.89 -25.81,-81.14 -27.31,-127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17605.2 11376.31c63.49,30.43 194.57,-22.73 228.13,-104.53 -79.73,-14.84 -182.12,38.17 -228.13,104.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5859.49 11411.1c-25.63,-360.98 -233.78,103.86 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13899.88 11492.34c75.49,2.79 115.66,-26.29 118.65,-92.79 8.45,-187.72 -244.22,-70.07 -118.65,92.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12193.31 11318.31c-34.58,-1.36 -49.11,22.73 -54.79,58 37.26,4.73 57.65,-11.81 54.79,-58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10103.36 11318.31c-23.86,19.98 -69.31,12.43 -63.95,69.66 19.26,18.04 83.42,-38.43 63.95,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7347.16 12037.78c92.7,10.6 93.19,-219.13 45.59,-278.49 19.47,-68.19 61.71,-107.23 45.67,-220.52 -33.33,-7.52 -48.67,7.84 -63.87,23.28 -38.26,-43.56 -25.48,-134.11 -18.3,-208.87 -9.34,-11.37 -18.43,-22.91 -27.39,-34.83 -122.14,116.66 -127.51,601.82 18.3,719.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14274.06 11411.1c8.1,5.09 16.37,10.19 18.31,23.24 39.9,-3.4 69.19,-20.38 63.86,-81.21 -32.89,-40.55 -90.71,-18.04 -82.17,57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19530.9 11422.69c10.44,13.78 10.29,41.06 9.11,69.62 46.36,55.33 145.2,29.55 127.76,-92.8 -48.44,-30.58 -109.39,-26.62 -136.87,23.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10431.83 11492.34c-41.89,-321.17 -217.25,147.17 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13288.38 11387.97c-23.96,-3.59 -29.9,15.91 -27.39,46.37 24.14,3.53 29.98,-16.13 27.39,-46.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12695.21 11527.18c0.34,207.66 227.3,45.1 146.05,-127.66 -95.7,-17.31 -103.86,76.81 -146.05,127.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13115.03 11631.67c77.32,-17.71 137.36,-57.45 155.15,-150.87 -51.27,6.27 -131.25,71.57 -155.15,150.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12375.76 11643.21c23.7,4.7 27.62,34.62 54.75,34.87 14.76,-16.06 28.9,-32.93 45.7,-46.41 18.51,-134.96 -119.18,-123.15 -100.46,11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13516.59 11538.76c-24.04,-3.41 -29.98,16.13 -27.39,46.49 23.79,3.18 39.24,-4.22 36.48,-34.91 -7.76,2.24 -8.59,-4.47 -9.08,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8433.15 11538.76c-64.96,10.19 -99.45,59.24 -109.48,139.31 8.1,5.17 16.29,10.16 18.2,23.13 49.19,0.66 54.43,-54.48 100.4,-58 -34.25,-35.31 1.06,-77.14 -9.11,-104.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15323.62 11608.49c21.14,38.31 69.89,14.34 73,-34.93 -28.48,-34.72 -67.98,-18.78 -73,34.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12019.88 11573.59c-4.35,44.25 3.83,72.52 27.39,81.21 24.79,-7 35.72,-31.82 36.48,-69.55 -22.87,-16.87 -35.82,-28.12 -63.87,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8287.23 11573.59c-9.2,0 -18.31,0 -27.48,0 -14.77,39.82 5.24,65.3 36.56,46.41 1.18,-20.71 -11.19,-24.45 -9.08,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7794.31 11782.54c27.23,11.77 58.37,18.58 82.18,34.83 -36.51,50.23 -97.63,69.15 -91.28,174.05 13.29,17.92 46.67,10.19 73.07,11.59 41.89,-62.66 43.59,-176.61 100.36,-220.46 23.3,-239.64 -170.01,-204.58 -164.33,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5996.46 11631.67c-13.53,6.05 -22.98,17.09 -36.51,23.13 36.85,146.87 97.02,298.47 246.41,266.95 73.56,-94.37 19.72,-240.81 -73.03,-255.25 -27.39,15.4 -53.89,32.05 -73,57.97 -26.9,-23.76 -50.69,-51.58 -63.87,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14703.09 11654.8c-31.83,40.59 -46.69,91.77 -36.59,162.56 104.96,4.04 56.63,-96.71 36.59,-162.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11809.96 12513.52c-40.94,53.93 -8.53,137.71 36.48,150.87 -29.81,81.98 -126.58,78.9 -145.95,174.04 76.32,87.26 191.86,-19.09 246.41,-69.55 95.53,15.84 161.5,-71.05 246.41,-104.49 64.13,-25.26 162.82,-13.05 136.87,-127.62 -117.66,-35.79 -176.54,88.76 -301.19,81.24 115.04,-114.06 288.57,-323.33 428.92,-475.78 17.79,-19.32 39.5,-0.55 73.07,-23.28 37.74,-25.59 63.38,-82.71 100.36,-116 47.7,-42.94 132.58,-55.58 145.96,-139.21 10.43,-64.35 -16.03,-123.26 -54.7,-162.56 -113.63,29.62 -190.36,106.06 -228.18,232.08 -57.39,11.81 -81.92,78.6 -145.98,92.9 -107.87,24.13 -236.56,-48.06 -328.56,23.18 -107.99,90.96 -103.63,324.69 -191.66,441.05 -27.97,8.36 -26.87,-20.1 -54.75,-11.69 0,19.43 0,38.75 0,58.07 24.88,8.47 18.36,-23.03 36.5,-23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8916.86 11701.21c-130.59,193.77 -249.32,402.49 -355.89,626.76 -21.36,17.3 -39.42,-3.93 -45.64,11.59 -0.44,29.62 6.74,14.11 18.2,11.55 -45.62,117.87 -66.41,318.2 45.67,336.57 70.87,11.59 110.98,-68.6 164.23,-116.03 19.38,-148.34 -61.61,-169.24 -91.26,-255.36 129,-149.19 191.8,-382.77 301.17,-556.99 1.85,-37.13 -15.25,-50.12 -36.48,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8798.21 11805.7c-24.22,4.04 -30.83,30.58 -36.51,58.07 25.32,-4.13 53.69,-34.71 36.51,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10194.54 11840.49c-25.63,2.24 -38.81,20.17 -36.48,58.12 26.7,10.38 28.05,10.38 54.79,0 1.41,-28.9 -14.27,-36.01 -18.31,-58.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1451.5 11863.77c-24.97,44.77 66.37,224.64 127.74,162.43 -15.43,-88.65 -91.93,-99.65 -127.74,-162.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8195.85 11898.61c-34.89,25.15 -92.67,21.22 -82.09,104.38 54.64,-0.26 73.23,-46.13 82.09,-104.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10504.9 12223.49c26.72,12.42 47.11,32.92 91.28,23.24 7.44,24.97 9.78,55.73 18.2,104.38 51.35,36.22 88.61,63.5 146.05,23.28 -29.39,244.91 -149.3,374.99 -146.05,661.44 27.97,7.04 36.74,38.46 54.79,57.96 171.68,-43.95 153.22,-280.73 164.23,-510.57 35.75,-93.89 144.28,-263.09 54.79,-371.39 -54.12,-10.74 -64.47,34.05 -91.25,58.03 -23.99,-42.97 -28.64,-110.39 -82.1,-116.03 -8.94,-106.69 64.96,-169.32 27.31,-243.67 -117.9,55.11 -239.58,105.33 -237.25,313.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8570.08 11944.99c-69.14,-10.6 -91.2,38.75 -91.26,116.03 44.67,41.76 105.04,-15.51 91.26,-116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15314.46 11968.13c-10.7,32.81 -1.76,49.38 9.17,81.24 52.94,9.43 71.17,-25.51 73,-81.24 -14.88,-17.38 -67.32,-17.38 -82.17,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10869.87 11968.13c-7.27,6.16 -14.79,12.13 -27.33,11.69 -6.35,42.9 14.47,51.18 45.61,46.38 7.85,-37.04 -14.35,-35.86 -18.28,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9382.32 11968.13c-25.63,-1.58 -26.3,28.48 -27.39,58.07 32.07,-5.06 38.67,-24.39 27.39,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7493.2 11968.13c-38.09,-0.41 -44.26,83.25 -27.39,116.18 43.77,7.63 44.49,-83.05 27.39,-116.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11052.48 12002.99c-74.21,89.38 -18.46,225.91 63.78,208.83 85.69,-17.63 100.45,-251.21 -63.78,-208.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7055.07 12002.99c-15.19,0 -30.39,0 -45.58,0 -12.03,166.56 -74.65,268.8 -73.07,452.57 33.12,-0.41 49.68,58.73 73.07,34.86 -47.86,-170.3 18.77,-340.63 45.58,-487.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6553.12 12037.78c-46.08,10.93 -23.87,157.14 27.39,150.91 13.44,-56.28 8.85,-126.71 -27.39,-150.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7027.69 12188.69c4.98,75.45 81.17,100.71 127.84,58.03 19.7,-139.06 -104.72,-154.57 -127.84,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4335.41 12188.69c-10.59,-1.94 -16.26,2.53 -18.28,11.55 42.84,96.39 97.28,178.03 191.66,208.94 -23.38,-117.29 -128.34,-130.77 -173.38,-220.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15533.48 12409.18c63.64,11.25 81.08,-36.3 109.54,-69.62 -16,-179.36 -204.4,-57.56 -109.54,69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9327.54 12258.31c-17.36,4.88 -16.53,33.1 -45.59,23.13 2.94,27.32 14.45,43.52 9.11,81.35 32.06,21.53 29.95,-8.9 54.78,-23.24 0.93,-36.01 -11.1,-55.44 -18.3,-81.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7493.2 12269.86c-13.52,36.78 52.42,55.88 45.59,11.59 -10.62,-9.65 -24.45,-15.28 -45.59,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16984.67 12513.52c56.77,-175.39 -168.01,-222.77 -191.72,-81.21 -16.52,98.81 44.93,134.81 136.93,139.28 14.53,-24.13 32.24,-44.06 54.79,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10477.39 12443.86c19.15,6.79 26.18,28.78 54.82,23.35 4.06,-10.52 7.99,-20.89 18.28,-23.35 12.28,-83 -88.95,-94.7 -73.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8424.06 12374.39c-129.83,-22 -252.26,252.13 -118.64,278.46 87.57,17.23 145.46,-144.83 118.64,-278.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7073.36 12710.78c6.6,-52.32 -3.03,-57.82 9.1,-92.76 99.85,35.57 148.7,-113.1 118.65,-243.66 -83.67,-5.03 -139.78,46.71 -155.15,127.58 -4.45,23.57 17.87,38.02 18.28,69.66 0.61,46.27 -53,141.19 9.11,139.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14328.83 12420.73c0,15.47 0,30.91 0,46.49 35.15,9.02 35.15,-55.61 0,-46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4381 12420.73c-19.03,-4.88 -24.2,7.95 -36.48,11.59 2.16,20.49 15.71,26.4 36.48,23.21 0,-11.66 0,-23.21 0,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13845.18 12443.86c-74.83,-29.18 -143.4,9.13 -155.24,69.66 -46.16,236.55 283.58,152.89 155.24,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8789.1 12525.22c29.06,17.72 40.16,4.04 72.98,0 27.3,-120.11 -98.44,-117.36 -72.98,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6242.87 12432.32c-86.27,3.71 -144.46,201.06 -54.79,255.33 26.64,-8.62 44.84,-28.12 63.95,-46.38 38.93,47 130.36,49.46 118.59,-58.07 -39.99,-53.53 -121.93,-53.86 -127.76,-150.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16245.4 12722.39c8.1,5.21 16.3,10.26 18.23,23.21 152.27,3.96 -18.14,-207.55 -18.23,-23.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7849.07 12699.22c-57.19,35.57 -132.5,48.1 -118.65,174.12 97.2,21.44 135.46,-88.94 118.65,-174.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7118.97 12884.93c15.92,91.95 32.12,183.46 63.95,255.24 7.99,-9.02 20.53,-12.43 36.48,-11.59 14.53,-66.98 -28.54,-163.37 -54.79,-243.66 -24.97,-76.45 8.46,-88.99 -27.39,-185.71 -150.54,-26.76 -136.09,257.49 -18.25,185.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6188.08 12710.78c-12.29,7.66 -17.04,24.89 -18.2,46.52 11.94,14.86 33.56,14.86 45.59,0 -2.68,-23.65 -24.66,-22.73 -27.39,-46.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5795.72 12850.09c39.06,7.34 58.7,-10.3 72.97,-34.79 3.66,-150.06 -160.91,-55.54 -72.97,34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6078.6 13035.79c61.12,24.02 111.24,-40.43 118.56,-81.21 43.69,-240.94 -217.66,-184.12 -118.56,81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6799.53 12942.89c53.12,105.45 201.49,29.73 164.33,-104.46 -51.61,-57.45 -84.52,-31.86 -146.05,0 -4.06,37.48 -17.51,62.95 -18.28,104.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11618.28 13256.32c73,0 146.04,0 219.05,0 110.77,-98.96 200.36,-224.9 319.35,-313.43 19.73,-217.53 -144.63,-88.87 -182.51,-23.13 -152.04,17.85 -352.2,159.48 -355.89,336.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8131.98 12826.85c-18.77,61.48 19.03,123.26 82.18,116.03 14.94,-39.6 -2.37,-83.34 -18.31,-116.03 -19.69,-26.15 -31.06,9.64 -63.87,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10130.64 12838.43c-15.19,0 -30.39,0 -45.58,0 -8.51,45.87 -8.51,69.11 36.5,69.74 10.52,-13.78 10.36,-41.1 9.08,-69.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13416.13 12908.16c5.02,40.77 52.97,18.59 73.07,11.59 -0.75,-35.38 -59.71,-27.16 -73.07,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6215.47 12896.47c0,19.32 0,38.79 0,58.11 15.2,0 30.39,0 45.67,0 1.99,-41.42 -13.21,-60.75 -45.67,-58.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6297.54 12942.89c-24.71,30.07 -84.43,65.62 -54.7,127.62 50.17,2.35 80.74,-70.28 54.7,-127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11061.59 12977.83c-39.59,57.86 -73.07,123.67 -82.18,220.42 73.56,-3.41 84.11,-148.23 100.46,-185.7 4.93,-25.7 -17.44,-16.46 -18.28,-34.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10313.19 12977.83c-19.52,43.33 -34.49,84.4 -9.09,127.52 46,-3.3 65.72,-40.26 73.04,-92.8 -21.94,-10.86 -24.22,-46.63 -63.95,-34.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8497.02 13499.91c10.52,52.43 25.05,99.79 54.79,127.74 30.21,-8.11 41.66,-39.97 54.75,-69.7 28.14,-8.69 11.13,40.04 45.61,23.13 176.61,-116.11 1.99,-352.04 45.67,-533.7 -63.86,-122.19 -57.69,-2.75 -63.86,104.49 -2.68,45.32 -43.95,109.96 -54.79,174 -12.6,73.99 -20.04,163.82 -82.18,174.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2455.4 13000.84c22.55,64.23 29.99,147.61 109.46,139.32 15.71,-107.01 -70.56,-139.62 -109.46,-139.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14155.4 13070.51c-1.41,-13.49 2.11,-20.6 9.17,-23.13 -18.36,-56.28 -63.02,23.47 -9.17,23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8159.37 13105.34c-45.61,21.66 -83.77,107.01 -82.09,150.97 58.88,-4.77 87.42,-102.36 82.09,-150.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5841.21 13105.34c-16.2,41.32 -43.3,68.7 -36.41,139.31 98.87,144.2 219.62,-174.04 36.41,-139.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10833.37 13140.17c-8.69,46.93 -41.32,63.5 -27.31,139.28 133.09,190.28 232.98,-221.56 27.31,-139.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10158.06 13163.42c21.94,-4.8 19.87,21.27 45.67,11.58 4.91,-41.76 -48.67,-68.92 -45.67,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3304.14 13151.86c-23.9,-3.33 -39.26,4.11 -36.5,34.84 25.63,11.77 38.9,13.12 36.5,-34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2738.32 13163.42c-1.41,28.89 14.36,35.89 18.2,57.96 22.06,4.8 19.9,-21.22 45.7,-11.55 0,-15.51 0,-30.91 0,-46.41 -12.2,-16.54 -51.79,-16.54 -63.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10203.73 13453.5c120.49,-63.4 241.14,-126.57 337.67,-220.43 11.18,-52.97 -32.01,-36.62 -36.51,-69.65 -71.71,64.34 -249.32,72.41 -319.45,162.45 -24.97,32.08 -19.81,100.13 18.28,127.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M292.43 13186.7c-49.94,59.65 44.92,115.08 91.25,127.59 10.27,-36.52 0.84,-26.33 0,-69.63 -43.68,-2.45 -72.66,-23.57 -91.25,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17577.83 13198.24c-19.03,-4.88 -24.14,7.95 -36.48,11.59 2.13,20.39 15.68,26.43 36.48,23.24 0,-11.69 0,-23.24 0,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8004.22 13198.24c-28.8,2.13 -21.19,85.69 -9.08,104.38 28.98,-21.78 28.37,-77.44 9.08,-104.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11353.59 13244.66c6.11,38.65 23.47,63.02 63.86,57.97 4.1,-10.3 8.05,-20.72 18.31,-23.18 9.08,-76.22 -64.3,-86.08 -82.17,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5275.42 13256.32c78.08,136.64 170.09,255.69 255.61,382.88 51.66,-11.47 54.61,38.75 109.48,23.24 -0.78,-16.45 -1.52,-32.92 9.17,-34.78 -42.35,-213.13 -249.26,-216.94 -328.58,-382.99 -21.14,-3.74 -35.07,1.87 -45.67,11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10806.07 13894.51c-99.87,33.92 -199.82,-104.85 -237.3,23.28 -79.67,-7.11 -158.42,-8.28 -209.91,46.28 -13.79,77.09 54,62.03 91.25,81.35 24.71,12.83 57.78,50.56 82.1,57.96 93.33,28.56 187.36,-36.11 273.86,-57.96 22.98,9.42 36.33,31.09 54.7,46.37 110.97,-29.18 141.54,-160.51 191.71,-266.9 117.41,115.81 225.14,-208.73 118.65,-290.08 14.44,-84.95 107.71,-100.02 109.48,-174.11 3.26,-138.55 -113.98,-55.88 -155.15,23.24 -26.53,271.79 -289.84,242.6 -319.39,510.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16902.52 13325.87c-37.28,-4.76 -57.64,11.88 -54.82,58.07 12.23,16.46 51.71,16.46 63.9,0 2.94,-26.99 -1.41,-44.58 -9.08,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12448.83 13349.04c-139.7,-67.43 -142.32,175.39 -63.9,208.9 81.92,35.09 179.69,-152.89 63.9,-208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2126.82 13360.7c-18.72,18.7 -21.22,58.18 -18.28,104.45 25.37,20.94 95.18,18.08 109.53,-11.65 -7.99,-59.47 -29.46,-101.82 -91.25,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6279.34 13383.94c-27.65,128.69 34.22,270.94 146.04,220.42 -11.88,-120.4 -49.36,-207.98 -146.04,-220.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5978.18 13383.94c-28.67,-5.49 -24.05,31.2 -45.62,34.72 10.52,13.82 10.29,41.1 9.11,69.77 17.62,-25.62 61.48,-61.48 36.51,-104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5238.94 13383.94c-66.24,70.8 -22.14,193.81 18.28,255.25 207.57,73.87 162.56,-297.41 -18.28,-255.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6826.92 13418.66c-30.83,143.25 122.65,148.96 100.36,11.69 -28.13,-33.35 -63.46,-36.96 -100.36,-11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9144.99 13430.35c-28.46,-5.31 -29.15,24.82 -27.39,58.07 37,12.94 45.18,-35.7 27.39,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11536.13 13441.91c-13.35,10.12 -28.93,17.41 -27.34,46.52 8.13,8.92 20.57,12.4 36.51,11.48 10.13,-36.34 4.27,-30.58 -9.17,-58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8999.04 13511.57c11.77,16.01 39.68,11.47 63.78,11.55 32.32,-71.09 -70.9,-118.57 -63.78,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4892.15 13441.91c-34.17,-0.85 -31.14,45.57 -36.5,81.21 95.26,83.88 145.46,225.03 292.02,243.81 -19.15,-192.38 -224.47,-147.91 -255.53,-325.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9966.4 13499.91c-23.35,128.43 83.24,134.92 118.65,69.62 18.36,-109.04 -80.56,-130.48 -118.65,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8460.51 13465.15c-39.64,26.77 -85.49,46.02 -72.97,139.21 68.73,53.87 118.51,-83.95 72.97,-139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8925.97 13499.91c-143.22,2.93 -129,276.65 -27.39,290.15 130.85,17.41 103.37,-212.32 27.39,-290.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10742.11 13604.36c50.26,9.87 66.11,-24.19 82.18,-57.96 -19.41,-75.27 -95.65,-13.27 -82.18,57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8159.37 13511.57c-43.77,7.52 -40.48,98.29 -18.28,127.62 29.78,3.08 26.38,-36.08 45.67,-46.41 4.93,-44.92 -23.21,-47.77 -27.39,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6042.13 13720.4c99.87,14.96 134.6,-53.08 136.84,-162.46 -70.96,-101.82 -204.49,51.92 -136.84,162.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5941.67 13523.12c-53.77,26.24 -89.58,131.36 -63.87,220.52 64.39,-18.87 72.15,-144.48 63.87,-220.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7246.71 13546.4c-43.51,2.64 -77.25,17.82 -72.98,81.25 27.45,17.3 72.23,-27.65 72.98,-81.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6516.64 13650.78c-89.96,-14.89 -229.72,-10.52 -219.1,139.28 -50.46,14.04 -21.71,-72.86 -82.1,-46.42 17.28,59.29 44.98,105.16 63.9,162.46 93.82,1.4 136.35,29.33 218.99,23.18 17.3,-24.34 -2.74,-96.31 36.59,-92.8 -9.2,-32.52 -42.27,-1.18 -45.67,11.66 -27.97,-40.15 27.88,-72.3 9.08,-139.32 44.26,-2.09 48.88,46.31 63.9,81.25 54,-47.48 119.31,-80.48 109.54,-208.99 -57.35,-48.57 -135.12,2.71 -155.13,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16081.08 13581.08c-12.2,0 -24.4,0 -36.51,0 -29.29,53.53 48.52,84.11 36.51,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7237.63 13627.65c-145.21,235.6 224.52,282.08 127.82,-23.29 -59.72,-13.89 -79.01,23.47 -127.82,23.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M0.4 13650.78c-7.87,76.22 105.79,73.14 118.56,23.24 -9.2,-80.58 -84.33,-49.57 -118.56,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9482.78 13650.78c-52.76,-9.02 -56.86,43.85 -82.18,69.62 21.8,92.28 105.56,-7.85 82.18,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7757.84 13674.02c-2.63,42.02 25.51,44.88 27.36,81.21 29.72,3.01 43.91,-13.82 45.67,-46.41 -16.53,-21.52 -46.16,-26.55 -73.03,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12211.5 13929.27c73.59,12.42 95.78,-40.66 136.93,-69.66 37.33,-291.44 -321.82,-95.76 -136.93,69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4746.12 13708.81c-9.11,0 -18.31,0 -27.39,0 -2.94,26.99 1.49,44.62 9.08,58.12 20.06,-1.69 19.72,-29.33 18.31,-58.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13452.64 13731.99c-64.56,-27.5 -167.67,24.86 -191.66,116.15 -42.64,162.78 111.06,345 283,255.24 82.75,-117.76 33.56,-333.05 -91.34,-371.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6836 13731.99c-48.58,0.1 -74.62,28.89 -82.06,81.35 38.93,28.64 80.25,-25.7 82.06,-81.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6680.87 13731.99c-9.1,0 -18.2,0 -27.39,0 -23.21,117.54 -113.65,149.59 -164.23,232.08 -11.93,81.02 17.93,108.74 27.39,162.56 55.18,0.54 114.91,6.82 146.04,-23.25 -14.21,105.89 -69.8,158.83 -63.97,290.19 114.58,-47.89 63.49,-306.32 155.23,-383.09 -44.69,-80.36 -95.03,-177.13 -73.07,-278.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2738.32 13766.93c3.93,109.66 54.38,200.32 127.76,185.58 25.07,-106.39 -55.36,-165.93 -127.76,-185.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9811.27 13848.14c18.11,-15.62 43.51,-22.18 63.87,-34.79 -16.63,-53.93 -59.86,1.87 -63.87,34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7474.89 13790.06c-21.28,0 -42.56,0 -63.84,0 6.84,39.6 -37.11,14.74 -27.39,58.07 34.54,26.43 90.33,-4.55 91.23,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6042.13 13801.76c-46.77,-31.97 -68.71,27.72 -109.57,57.86 -28.8,249.08 230.64,66.66 109.57,-57.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2345.87 13871.3c-14.22,-36.11 -44.29,-52.06 -63.9,-81.24 -66.9,24.52 15.11,134.73 63.9,81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12001.65 13848.14c22.47,1.5 43.94,1.68 54.7,-11.66 -0.41,-34.84 -64.8,-33.7 -54.7,11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5877.8 13836.48c-15.53,36.18 -19.9,61.23 0,92.8 18.77,-22.4 55.7,-22 45.59,-81.14 -10.61,-9.76 -24.48,-15.4 -45.59,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2172.49 13836.48c2.24,95.32 59.31,177.71 136.87,139.28 -6.69,-95.98 -62.8,-128.98 -136.87,-139.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11746.07 13882.86c19.2,93 132.6,0.1 182.54,-11.56 -44.2,-59.97 -132.63,3.71 -182.54,11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15250.59 13917.79c21.11,3.6 35.06,-1.94 45.59,-11.69 2.24,-56.13 -60.47,-62 -45.59,11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5768.32 13882.86c-41.01,-20.61 -118.56,43.95 -109.57,127.62 23.07,216.27 240.65,-61.71 109.57,-127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3687.49 13871.3c-25.97,11.03 -3.26,126.57 45.59,116.04 14.7,-36.22 -28.46,-83.26 -45.59,-116.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3249.45 13906.1c42.15,74.03 41.75,202.16 155.04,185.7 64.96,-138.14 -57.34,-276.25 -155.04,-185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16300.19 13917.79c-15.37,54.99 52.42,63.94 45.59,11.48 -10.62,-9.68 -24.48,-15.29 -45.59,-11.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11098.07 14057.01c58.3,70.47 131.71,-39.83 91.28,-127.74 -51.52,-21.89 -82.75,58.69 -91.28,127.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18335.35 13975.76c16.38,-1.47 19.2,14.23 36.51,11.59 31.31,-45.03 -39.76,-70.39 -36.51,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2555.81 14057.01c26.64,24.08 74.3,70.24 118.64,34.78 22.06,-120.91 -150.97,-233.91 -118.64,-34.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6963.85 14057.01c35,16.86 85.69,-34.84 100.36,-81.25 -32.89,-58.41 -122.31,31.42 -100.36,81.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6854.31 14091.79c52.01,-11.25 94.52,-34.49 91.25,-116.03 -41.08,-49.79 -152.29,38.97 -91.25,116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4362.8 13964.07c13.6,13.63 10.69,48.31 36.5,46.41 -1.18,-20.68 11.19,-24.42 9.09,-46.41 -11.94,-14.86 -33.56,-14.86 -45.59,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11399.26 13964.07c-29.24,-3.19 -33.17,50.95 -18.29,69.65 29.81,3.12 43.92,-13.68 45.67,-46.37 -7.43,-10.01 -25.05,-6.93 -27.38,-23.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4992.53 13964.07c-11.94,4.18 -14.39,20.52 -27.39,23.28 -1.41,28.85 14.35,35.89 18.28,58.07 26.56,-0.22 21.54,-65.63 9.11,-81.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12339.26 14033.72c-52.27,189.01 168.99,262.14 191.72,92.91 17.44,-130.38 -103.29,-212.32 -191.72,-92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16510.04 14022.17c-8.1,83.12 97.89,42.05 91.38,-11.69 -19.9,-19.32 -82.36,-18.59 -91.38,11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6142.38 13998.89c-13.44,6.04 -22.95,17.24 -36.48,23.28 0.18,31.83 43.08,27.61 54.75,11.55 -3.16,-15.18 -16.02,-18.22 -18.28,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6133.33 14219.43c42.96,40.25 63.95,-29.92 91.26,-46.38 -19.29,-42.27 -12.03,-53.53 0,-104.49 -73.15,-50.85 -88.53,110.94 -91.26,150.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5905.19 14057.01c-7.69,13.45 -12.03,31.09 -9.11,57.96 11.68,16.02 39.57,11.44 63.87,11.66 -6.83,-35.79 25.05,-22.29 18.23,-58.07 -30.34,48.54 -28.55,-17.19 -72.98,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4399.3 14126.63c-26.99,159.15 116.64,174.88 136.85,81.24 21.13,-97.6 -66.29,-149.62 -136.85,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5439.65 14126.63c27.33,42.78 57.47,81.79 118.77,81.24 -6.03,-64.78 -71.17,-107.16 -118.77,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3650.98 14149.76c-3.6,108.97 37.67,160.87 91.29,197.28 139.52,-50.75 6.35,-316.41 -91.29,-197.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3331.54 14196.18c-7.38,70.9 43.34,118.09 91.23,81.32 8.13,-71.86 -57.34,-100.21 -91.23,-81.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4043.33 14196.18c-19.03,-4.88 -24.14,7.95 -36.48,11.69 14.27,36.41 44.58,99.8 82.18,69.63 2.56,-49.9 -43.11,-38.21 -45.7,-81.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4162 14231c-52.48,140.06 40.97,202.68 109.54,255.36 139.29,-44.17 -11.01,-169.89 -18.28,-266.94 -37.16,-12.73 -53.12,0.76 -91.26,11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4828.27 14242.56c-28.81,-5.62 -32.24,21.05 -63.87,11.73 -14.19,57.19 -14.39,133.52 54.69,116 15.37,-33.33 25.64,-86.09 9.18,-127.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6197.13 14254.29c-54,-14.16 -89.32,42.75 -63.84,92.75 42.97,-3.3 69.03,-28.23 63.84,-92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5576.6 14254.29c-12.45,34.39 -13.17,84.07 9.18,104.45 31.75,-13.82 59.63,-32.52 54.72,-92.9 -11.7,-16.06 -39.59,-11.47 -63.9,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11554.35 14335.46c27.49,15.44 69.89,11.81 109.57,11.59 3.89,-22.07 19.69,-29.19 18.28,-57.97 -45.61,-30.46 -115.33,-2.85 -127.85,46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2692.68 14277.5c-35.84,73.8 56.57,148.11 82.15,81.24 -14.79,-43.11 -37.49,-76.14 -82.15,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5959.95 14312.25c-75.63,4.44 -59.11,126.12 -91.26,185.7 -52.58,-29.88 -76.72,-95.91 -146.04,-104.37 0.31,113.17 84.83,73.25 91.26,162.42 3.03,42.38 -40.22,77.76 -54.75,127.66 -20.47,70.25 -13.47,138.44 -36.51,197.24 15.63,-0.51 23.61,8.61 27.39,23.18 93.02,-70.95 167.49,-174.48 173.35,-382.92 3.78,-21.41 43.43,39.2 63.95,0 -22.89,-65.7 -48.27,-115.16 -27.39,-208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6790.41 14509.54c0.11,30.91 -3.49,66.36 9.11,81.21 84.51,-70.25 194.39,18.81 237.33,-115.93 -18.97,-38.75 -26.5,-82.89 18.2,-92.8 -76.99,-85.46 -217.95,-63.39 -219.05,92.8 -0.9,29.73 -33.97,18.59 -45.59,34.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3906.51 14335.46c-7.09,59.36 17.05,78.9 54.7,81.25 4.06,-10.3 8.1,-20.72 18.28,-23.13 1.9,-65.74 -31.83,-75.27 -72.98,-58.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17660 14347.05c-6.71,-25.89 -52.12,-5.61 -45.69,23.25 29.06,10 34.66,-10.16 45.69,-23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3121.6 14358.74c-14.7,-3.3 -15.68,10.93 -27.39,11.56 -4.09,106.61 65.23,187.42 136.93,127.65 3.93,-97.78 -69.95,-96.64 -109.54,-139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6252.03 14474.78c13.21,51.29 40.94,3.3 54.7,-11.66 -8.95,-45.65 -44.49,-7.85 -54.7,11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3842.56 14497.99c-11.04,56.57 20.7,58.92 27.46,92.75 37.82,-16.86 14.35,-105.51 -27.46,-92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10395.36 14579.2c-0.08,66.47 100.98,80.48 118.65,23.24 1.24,-101.07 -99.02,-91.5 -118.65,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12649.62 14625.58c-98.43,-144.27 -278.55,-67.28 -292.08,92.9 -26.95,319.3 395.23,262.8 292.08,-92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4654.89 14556.02c-7.59,63.72 9.77,95.8 36.5,116.08 50.12,1.8 59.63,-47.88 54.7,-116.08 -26.5,-15.03 -64.82,-15.03 -91.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17924.61 14579.2c-3.95,22.18 -19.64,29.22 -18.22,58.07 17.82,13.6 51.03,38.12 72.97,11.59 4.84,-52.58 -13.44,-75.82 -54.75,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4125.51 14614.02c-23.13,48.84 16.78,55.62 18.28,104.46 24.22,-0.11 52.1,4.36 63.89,-11.59 22.12,-53.05 -29.72,-136.42 -82.17,-92.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10623.57 14625.58c-85.75,65.18 -142.06,229.47 -155.23,348.14 55.53,13.72 67.13,-101.37 91.28,-162.3 26.3,-66.39 74.39,-130.3 63.95,-185.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11736.96 14846.1c81.34,-188 -129.08,-246 -136.93,-92.87 -3.91,76.11 48.85,132.47 136.93,92.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3979.49 14706.89c-81.17,106.11 58.85,277.76 127.76,150.8 -11.85,-89.31 -38.57,-159.7 -127.76,-150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6726.55 14718.48c-36.33,6.71 -28.89,81.98 -18.28,116.08 15.2,0 30.39,0 45.67,0 7.44,-59.8 -20.78,-74.35 -27.39,-116.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15962.43 14764.9c28.72,12.94 24.1,5.43 45.67,-11.66 -0.87,-34.53 -54.44,-31.05 -45.67,11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3778.75 14776.59c-5.94,75.28 25.77,103.61 72.97,81.1 12.69,-70.73 -29.98,-118.38 -72.97,-81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1798.29 14776.59c17.44,59.03 52.84,95.14 109.45,104.35 4.09,-10.38 8.1,-20.8 18.39,-23.25 10.18,-88.99 -73,-112.66 -127.84,-81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12722.6 14950.59c153.4,-169.67 -155.07,-117.1 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6662.68 14962.15c29.13,-9.31 51.68,-27.06 54.67,-69.52 -35.87,-42.16 -73.79,41.5 -54.67,69.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4974.3 14904.1c-18.2,15.59 -43.51,22.18 -63.95,34.91 0,26.98 0,54.03 0,81.09 28.37,-1.14 26.04,36.66 63.95,23.28 26.24,-53.71 30.91,-89.82 0,-139.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4727.81 15020.08c25.81,13.71 38.83,2.38 63.95,-11.56 47.06,-127.18 -123.81,-129.2 -63.95,11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4828.27 14939.01c-13.01,35.67 -4.1,52.13 9.1,81.09 18.11,-0.07 11.63,-31.6 36.48,-23.13 0,-15.51 0,-30.98 0,-46.38 -10.58,-9.78 -24.45,-15.4 -45.58,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14566.14 14985.43c-41.01,8.47 -46.34,76.33 9.1,69.52 1.24,-28.53 1.42,-55.84 -9.1,-69.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4499.67 14985.43c-6.95,86.11 8.18,144.26 73.07,139.21 -3.43,-19.76 7,-21.89 18.2,-23.18 -0.18,-77.32 -22.15,-126.67 -91.26,-116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6169.88 15008.56c-42.35,40.81 -139.12,68.38 -100.46,174.11 65.49,-11.33 106.97,-109.25 100.46,-174.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5111.17 15008.56c-68.04,84.95 36.51,175 82.15,81.24 4.27,-67.31 -27.94,-88.24 -82.15,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10231.09 15124.64c14.71,-3.34 15.71,10.92 27.39,11.55 29.15,-1.46 40.11,-26.33 36.51,-69.52 -31.06,-38.56 -75.57,-18.4 -63.9,57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12731.72 15078.22c57.83,94.14 175.46,34.49 273.8,23.24 115.48,-13.27 231.62,18.37 319.48,11.59 0,-11.59 0,-23.25 0,-34.83 -176.96,-19.54 -416.25,-18.93 -593.28,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16646.99 15124.64c28.64,5.5 35.64,-16.61 54.67,-23.18 -3.83,-39.48 -66.63,-26.03 -54.67,23.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2519.3 15078.22c-40.34,110.28 93.19,218.84 155.15,127.58 -4.84,-101.99 -72.4,-124.5 -155.15,-127.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5804.8 15089.8c-52.77,-9.34 -83.73,80.37 -45.64,116 39.9,-3.81 68.53,-69.21 45.64,-116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5914.28 15101.46c-26.12,20.94 -64.21,26.65 -63.87,81.21 51.45,11.18 66.7,-23.57 63.87,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6206.36 15136.15c27.13,48.72 81.08,118.38 146.07,81.35 0,-19.37 0,-38.79 0,-58.12 -35.35,-23.86 -110.17,-71.24 -146.07,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6516.64 15147.8c-26.38,5.14 -41.69,24.46 -45.59,57.97 33.07,3.33 62.02,-33.63 45.59,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10231.09 15263.88c34.74,5.43 56.95,-4.98 63.9,-34.83 -4.94,-69 -81.75,-47.89 -63.9,34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7064.22 15194.23c-32.81,-6.79 -44.15,13.49 -63.95,23.28 0.08,30.8 -3.43,66.1 9.2,81.21 15.2,0 30.39,0 45.59,0 18.43,-15.4 27.56,-77.66 9.17,-104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6553.12 15205.77c-18.11,0.25 -11.59,31.75 -36.48,23.28 -5.63,143.76 -91.69,185.15 -136.95,278.49 25.81,94.18 -11.11,140.06 9.2,232.12 115.73,-114.13 167.41,-327.48 164.23,-533.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5932.56 15205.77c0,19.35 0,38.79 0,58.11 18.23,0 36.51,0 54.79,0 0,-15.5 0,-31.02 0,-46.37 -10.87,-13.53 -32.29,-13.21 -54.79,-11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6471.05 15229.05c-28.13,22.18 -44.09,60.09 -82.17,69.66 9.77,53.49 62.02,26.87 91.25,11.44 -15.86,-34.47 2.94,-58.7 -9.08,-81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14949.39 15252.37c-1.15,28.55 -1.33,55.8 9.17,69.62 32.82,-4.66 58.14,-19.03 63.9,-58.07 -13.29,-17.92 -46.77,-10.3 -73.07,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6680.87 15635.17c20.21,24.34 60.79,9.13 73.07,-11.58 9.69,-43.3 -22.72,-33.11 -18.28,-69.63 81.31,-59.02 71.4,-234.12 191.63,-243.8 -14.7,-88.55 -81.33,-45.21 -118.64,-11.44 -35.82,128.47 -156.57,157.32 -127.77,336.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10614.36 15345.09c26.29,-1.36 59.8,6.27 73.05,-11.65 -11.36,-46.72 -76.23,-64.9 -73.05,11.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4764.37 15287.13c-66.2,-17.09 -61.87,145.03 9.11,115.93 23.79,-35.96 0.31,-86.3 -9.11,-115.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4983.42 15646.72c-81.31,11.07 -109.57,60.67 -91.26,174.15 23.79,13.56 46.25,-32.08 45.59,46.41 46.08,-36.66 100.11,-110.43 54.79,-197.18 34.56,-18.14 84.42,-16.57 82.15,-81.35 81.68,84.43 207.78,29.73 200.74,-81.21 -10.27,-164.14 -205.58,-94.7 -292,-69.66 5.33,-342.83 -264.95,116.19 -45.67,127.74 19.69,21.45 24.1,62.22 45.67,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4490.56 15484.3c-7.76,34.06 -29.38,-6.89 -45.59,0 -18.13,80.59 18.11,85.13 54.7,81.32 37.74,-4.03 112.22,74.65 136.84,0 0.09,-38.75 0,-77.4 0,-116.15 -25.81,-69.95 -184.85,-90.33 -145.95,34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6963.85 15426.34c-73.96,-67.87 -90.43,109.48 -173.44,104.46 7.21,40.04 -8.51,50.95 -27.39,57.96 -4.32,36.56 12.98,45.46 18.23,69.66 -58.88,6.38 -97.69,38.24 -146.05,58 26.74,61.37 -7.09,138.04 45.67,174 -3.75,26.21 -49.99,-1.69 -45.67,34.94 28.9,80.48 61.48,98.52 63.95,197.28 39.16,18.48 61.97,49.9 100.37,46.37 143.65,-12.93 122.83,-346.97 127.76,-475.78 -21.28,0 -42.58,0 -63.86,0 2.56,-128.25 64.79,-180.71 100.43,-266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13452.64 15461.16c-30.65,-11.87 -14.22,36.08 -18.23,57.97 18.57,-8.51 37.26,-34.84 18.23,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15086.36 15472.72c-7.39,37.91 -27.16,44.4 -27.42,69.65 -1.93,209.06 289.75,-84.07 27.42,-69.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6918.2 15577.21c40.83,27.06 79.15,45.2 118.65,46.38 36.79,30.5 57.67,81.24 100.34,104.49 -19.35,-52.76 3.77,-104.38 63.89,-139.32 -3.52,-135.58 -276.65,-180.89 -282.89,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13051.16 15774.45c175.02,117.87 334.27,-64.19 419.76,-174.11 64.7,1.06 130.76,3.85 118.65,-92.8 -54.26,-73.14 -85.32,30.8 -146.05,46.41 -36.9,9.57 -61.27,-22.73 -100.36,-23.17 -134.37,-1.69 -278.14,80.48 -292,243.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6598.7 15507.54c-31.14,-4.25 -38.5,67.21 0,58.07 1,-28.96 17.12,-36.01 0,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11700.45 15704.83c1.82,36.34 -6.17,85.13 9.08,104.46 157.35,25.92 204.75,-87.77 273.84,-174.12 -60.96,-64.23 -212.44,32.71 -282.92,69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4664 15728.08c76.41,-200.77 -154.67,-54.04 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14310.55 15890.42c30.04,39.3 74.65,59.87 127.85,69.74 162.04,-130.67 -142.21,-382.22 -127.85,-69.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6598.7 15739.66c-6.03,0 -12.11,0 -18.2,0 1.67,9.85 -3.58,10.92 -9.11,11.58 0,7.74 0,15.47 0,23.21 7.79,-2.09 8.59,4.58 9.11,11.59 6.09,0 12.16,0 18.2,0 -1.65,-9.87 3.6,-10.92 9.2,-11.59 0,-7.74 0,-15.47 0,-23.21 -7.79,2.09 -8.62,-4.58 -9.2,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12558.28 15809.28c-14.35,137.81 47.93,166.08 127.85,127.66 23.87,-127.34 -58.53,-189.66 -127.85,-127.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1871.33 15890.42c8.04,87.37 120.08,59.8 118.59,-23.13 -32.07,-67.31 -105.14,-56.91 -118.59,23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9875.14 15878.98c-0.75,18.23 4.42,44.25 -9.08,46.38 6.35,22.84 24.28,30.9 45.59,34.79 37.92,-32.45 11.59,-125.02 -36.51,-81.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4946.83 15971.73c-7.23,40.26 13.61,44.63 9.23,81.25 26.3,-1.39 59.68,6.35 72.95,-11.59 34.22,-63.27 -38.41,-107.79 -82.18,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14301.53 16076.23c18.2,0 36.41,0 54.69,0 8.1,-24.53 27.8,-34.28 27.39,-69.66 -37.65,-18.15 -92.46,-22.74 -82.09,69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11727.84 16029.7c100.34,103.98 233.21,127.11 383.26,104.49 144.77,-21.78 268.03,108.75 392.45,69.66 -30.39,-115.52 -154.98,-70.1 -273.8,-104.49 -130.59,-37.7 -342.86,-168.4 -501.91,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14000.33 16041.39c-1.5,28.9 14.27,35.86 18.2,57.97 55.53,-7.95 27.74,-99.69 -18.2,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14556.94 16041.39c-24.77,7.12 -42.64,23.06 -54.67,46.41 -11.27,37.48 29.55,8.92 18.28,46.38 34.08,12.43 25.95,-28.78 54.69,-23.13 7.27,-40.25 -10.12,-49.1 -18.3,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15807.28 16111.06c11.67,15.81 43.07,15.81 54.78,0 0,-15.51 0,-31.09 0,-46.53 -25.63,-13.89 -58.21,-6.67 -54.78,46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6571.39 16145.78c-2.83,61.23 89.22,37.17 82.09,-11.59 -14.67,-15.28 -80.41,-25.04 -82.09,11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14794.27 16215.4c98.29,27.21 217.34,22.11 292.1,-11.55 -74.82,-13.6 -279.83,-97.57 -292.1,11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15661.32 16192.26c4.68,38.75 82.1,26.33 100.37,11.59 -9.2,-43.11 -81.95,-46.53 -100.37,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7009.46 16180.6c-45.67,0 -51.61,50.53 -73.07,81.21 -12.14,-30.9 -30.73,-53.71 -63.81,-57.96 -7.93,9.34 -5.42,31.86 -18.28,34.83 5.19,32.05 9.59,65.08 45.58,57.97 -20.03,36.4 -85.43,15.18 -109.48,46.49 -0.05,30.8 3.43,66.25 -9.17,81.14 -25.81,-1.91 -62.54,10.08 -63.9,-23.18 -9.25,46.94 -51.76,88.07 -54.67,174.05 24.89,-8.36 18.37,23.13 36.48,23.24 57.27,-62.5 161.99,-64.67 209.92,-139.17 27.39,7.52 31.83,44.59 73,34.68 28.29,-56.86 -4.09,-122.38 -36.51,-139.17 -12.77,-101.38 66.58,-85.47 63.9,-174.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6580.51 16319.78c58.7,36.3 103.72,5.43 173.43,0 -26.2,-91.73 -166.69,-158.65 -173.43,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13115.03 16238.68c-32.56,-2.79 -47.75,16.68 -45.67,57.97 31.49,40.99 74.56,-22.07 45.67,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11271.5 16250.23c-19.11,-4.89 -24.22,7.99 -36.56,11.58 -3.83,24.34 6.25,30.69 9.17,46.38 28.49,5.36 29.16,-24.75 27.39,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14931.23 16308.19c0,27.21 0,54.26 0,81.35 140.6,136.93 139.09,-223.38 0,-81.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13461.84 16319.78c-29.36,-10.08 -12.57,38.31 -36.51,34.94 13.7,26.99 22.29,17.63 45.59,11.59 3.93,-24.34 -6.25,-30.69 -9.08,-46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4691.38 16598.38c90.28,14.27 146.8,-14.44 182.44,-69.62 43.68,-421.85 -416.3,-114.06 -182.44,69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11326.2 16343.13c-19.03,-4.99 -24.14,7.88 -36.48,11.59 2.16,20.38 15.68,26.32 36.48,23.17 0,-11.58 0,-23.17 0,-34.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10979.41 16343.13c0,11.59 0,23.18 0,34.75 16.2,-2.67 45.67,11.66 36.51,-23.17 -8.1,-9.13 -20.56,-12.54 -36.51,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9993.8 16389.55c7.76,-2.23 8.62,4.48 9.11,11.55 81.66,-2.01 -7.53,-115.41 -9.11,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15743.41 16377.89c-23.91,-3.33 -39.24,4.22 -36.51,34.79 23.87,3.3 45.67,3.93 36.51,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10331.49 16377.89c-21.13,-3.74 -35,1.87 -45.58,11.66 8.25,20.27 16.92,40.25 45.58,34.72 0,-15.4 0,-30.91 0,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7219.4 16377.89c-21.71,7.3 -42.5,15.59 -45.67,46.38 -27.71,-14.96 -42.58,-46.38 -91.26,-34.72 -40.16,49.49 -46.02,142.58 -63.89,220.42 53.77,34.17 182.77,3.19 209.94,-69.66 -10.03,-69.33 -36.9,-97.78 -9.11,-162.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15825.56 16482.34c-9.6,81.76 23.06,109.87 82.09,104.46 9.2,-15.47 15.11,-35.01 27.39,-46.5 -3,-72.19 -67.13,-100.97 -109.48,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9866.06 16482.34c-24.07,-3.49 -30.01,16.06 -27.39,46.41 12.17,0 24.28,0 36.48,0 3.93,-24.23 -6.2,-30.68 -9.08,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14812.55 16528.76c-6.09,0 -12.17,0 -18.28,0 1.67,9.87 -3.52,10.93 -9.08,11.55 0,7.78 0,15.51 0,23.29 7.76,-2.17 8.59,4.54 9.08,11.55 6.11,0 12.19,0 18.28,0 -1.68,-9.75 3.52,-10.93 9.1,-11.55 0,-7.78 0,-15.51 0,-23.29 -7.78,2.24 -8.59,-4.43 -9.1,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7009.46 16598.38c-9.2,0 -18.2,0 -27.39,0 0,15.51 0,30.91 0,46.38 30.48,11.69 29.96,-15.98 27.39,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6489.25 16621.63c-0.75,74.35 48.27,85.61 91.26,104.38 -8.69,-62.44 -45.01,-89.72 -91.26,-104.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11399.26 16702.88c6.78,63.39 84.16,52.53 91.28,0 0,-80.48 -85.11,-64.16 -91.28,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6936.4 16772.5c59.78,71.38 130.5,-52.21 127.82,-92.87 -62.94,-38.24 -120.23,22.81 -127.82,92.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11098.07 16679.63c-15.2,0 -30.45,0 -45.59,0 7.27,25.59 18.31,46.31 45.59,46.38 0,-15.37 0,-30.87 0,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7219.4 16679.63c-35.72,-6.71 -53.02,9.97 -72.98,23.25 27.54,74.2 -53.07,47.88 -36.56,139.17 78.14,46.02 65.8,-83.95 127.77,-92.75 4.37,-36.56 -28,-26.36 -18.23,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10614.36 16702.88c-21.14,-3.71 -34.98,1.8 -45.59,11.58 11.7,19.83 18.85,45.65 45.59,46.38 0,-19.32 0,-38.65 0,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4444.97 16737.7c16.21,41.17 20.3,97.89 82.06,81.21 9.2,-15.5 8.62,-43.23 27.39,-46.41 -8.33,-63.8 -80.41,-93.6 -109.46,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7365.45 16714.45c-14.79,-3.3 -15.72,10.93 -27.49,11.56 -2.65,30.58 12.69,38.12 36.59,34.83 3.84,-24.2 -6.28,-30.68 -9.1,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6890.81 16714.45c-33.42,10.93 -29.9,56.47 9.08,58.04 10.09,-36.49 4.35,-30.65 -9.08,-58.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7429.3 16726.01c-97.02,61.48 -271.61,106.28 -273.77,243.77 -1.75,108.63 108.44,95.76 136.85,197.17 71.3,8 56.02,-60.82 54.78,-92.79 128.92,-44.92 125.92,-213.42 82.15,-348.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6635.2 16737.7c18.14,15.62 35.59,32.15 27.48,81.21 43.74,5.43 71.54,-9.57 72.98,-58.07 -40.83,-14 -64.38,-33.32 -100.46,-23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2866.08 16772.5c10.62,-2.01 16.21,2.57 18.23,11.59 23.27,-1.5 35.41,-16.87 36.56,-46.38 -18.05,-21.56 -67.21,-17.31 -54.79,34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7712.22 16749.29c-46.25,-0.85 -72.23,24.3 -73.07,81.21 11.77,15.91 39.65,11.47 63.87,11.55 18.62,-32.71 16.38,-47.55 9.2,-92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4609.22 16969.78c64.12,54.26 77.16,158.53 173.35,116.08 90.02,-86.34 55.3,-293.16 -100.37,-255.36 -39.06,52.76 -49.93,78.97 -72.97,139.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5220.74 16842.04c-2.77,30.58 12.57,38.17 36.48,34.84 2.77,-30.58 -12.6,-38.09 -36.48,-34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4481.4 16900.16c-6.55,74.09 14.58,112.95 73.03,104.37 -3.34,-19.79 7.09,-21.88 18.31,-23.17 14.42,-80.04 -46.51,-114.03 -91.34,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5914.28 16946.53c0,19.32 0,38.65 0,58 10.62,-1.83 16.3,2.54 18.28,11.66 15.97,-10.74 31.66,-21.56 27.39,-58.07 -10.58,-9.79 -24.48,-15.28 -45.67,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5531.02 17062.58c-6.03,57.78 28.54,64.16 45.58,92.83 27.14,-4.14 46.34,-18.48 63.9,-34.72 0,-31.02 0,-62.03 0,-92.94 -46.69,-37.64 -84.45,-10.07 -109.48,34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5722.65 17051.03c0,15.36 0,30.87 0,46.37 25.55,26.65 72.57,6.38 63.9,-46.37 -25.81,-12.21 -38.09,-12.21 -63.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18025.04 17074.16c47.52,74.54 140.14,54.15 219.05,69.65 104.29,20.5 211.1,88.04 301.11,69.56 -128.86,-87.29 -390.07,-166.49 -520.16,-139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10906.44 17051.03c3.83,39.7 -27.39,34.83 -36.57,57.96 -20.56,121.58 74.83,156.91 136.93,104.38 35.32,-97.49 5.76,-185.08 -100.36,-162.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6169.88 17178.65c13.17,128.25 138.78,59.65 136.85,-11.7 -2.52,-93.85 -121.16,-94.29 -136.85,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4508.79 17271.41c54.67,8.39 144.77,31.35 155.21,-58.03 17.79,-153.99 -218.94,-151.53 -155.21,58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20744.68 17108.99c-35.15,-9.17 -35.15,55.55 0,46.41 -0.84,-31.67 15.2,-23.38 0,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10267.6 17120.68c-3.75,27.9 16.61,25.16 9.11,57.97 13.52,-6.05 23.03,-17.19 36.48,-23.25 -8.25,-20.27 -16.96,-40.36 -45.59,-34.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6817.81 17248.27c-27.62,-11.33 -48.93,-30.65 -82.15,-34.9 -2.68,23.75 -24.71,22.8 -27.39,46.49 9.18,46.38 26.47,82.3 82.15,69.66 58.88,182.28 -159.8,397.31 -9.17,464.08 60.03,26.65 90.28,-11.99 146.04,-34.72 -0.4,-73.08 6.92,-155.75 -18.22,-197.25 21.16,-35.05 65.82,-40.18 100.4,-58.11 6.25,108.08 43.66,176.46 127.74,185.7 -22.29,52.76 -41.58,109.58 -54.75,174.04 77.88,93.23 175.42,70.8 255.49,0 5.53,-97.26 -26.04,-142.47 -72.95,-197.28 24.45,-11.43 41.37,-32.37 72.95,-34.72 49.85,49.5 112.56,51.18 182.54,23.13 59.42,57.34 156.16,43.23 200.82,139.22 42.33,7.43 56.46,-21.05 72.98,-46.42 -1.59,-32.66 -43.34,-14.41 -36.48,-57.96 41.49,-35.86 177.41,-5.09 173.4,92.8 101.88,-23.03 213.11,59.8 301.17,-23.13 0,-31.03 0,-61.9 0,-92.91 8.31,-31.64 20.39,35.35 36.51,0 -0.05,-64.23 -68.88,-132.42 -127.82,-150.87 -27.74,-8.72 -125.6,-71.45 -182.46,-11.58 -201.31,-96.17 -353.29,-115.09 -547.58,-208.84 -45.61,-11.59 -44.69,36.01 -82.2,34.84 2.01,37.25 -16.09,49.05 -9.08,92.8 -110.72,-21.67 -74.65,-229.99 -182.54,-255.37 -61.22,30.5 -90.17,102.03 -136.93,150.87 -20.88,-23.57 -3.26,-96.31 -9,-139.17 -60.98,-84.11 -145.15,-13.94 -173.46,69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4435.77 17155.4c-24.94,0.29 -21.62,54.78 -9.08,69.62 26.79,-15.91 30.31,-47.77 9.08,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6334.1 17190.24c-22.73,109.44 51.27,277.82 72.97,406.19 66.06,-11.88 30.65,-80.19 9.18,-127.74 2.8,-131.21 -53.66,-187.05 -82.15,-278.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6471.05 17213.37c-54.2,-15.51 -44.02,83.11 9.08,58.03 2.94,-26.94 -1.49,-44.54 -9.08,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17450.07 17248.27c34.58,102.98 201.9,37.17 282.92,81.25 -6.78,-35.79 25.02,-22.33 18.2,-58.12 -97.63,3.74 -199.5,-45.42 -301.11,-23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7821.68 17271.41c1.35,43.04 42.93,76.37 73.07,46.41 0,66.36 -10.09,74.03 9.13,116.08 24.05,3.49 29.96,-16.06 27.36,-46.41 16.2,10.3 23.22,32.37 54.79,23.25 27.22,-43.08 -3.26,-90.45 -18.31,-116.04 -68.6,15.29 -93.19,1.06 -146.04,-23.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8414.95 17410.73c84.11,85.06 202.67,-8.07 237.25,-92.91 -73.15,-42.56 -250.24,-66.13 -237.25,92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15898.62 17399.1c0,15.51 0,30.98 0,46.38 20.73,5.75 46.51,23.06 63.81,0 8.74,-52.65 -38.32,-72.92 -63.81,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4901.24 17387.52c6.69,23.57 27.48,47.36 45.59,23.24 -1.33,-25.37 -22.96,-24.93 -45.59,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6343.18 17399.1c-45.07,-18.48 -57.09,40.12 -36.48,69.63 31.49,1.39 42.42,-23.47 36.48,-69.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2263.66 17457.14c1.36,60.75 46.11,43.67 73.07,23.28 4.61,-64.57 -52.02,-47.48 -73.07,-23.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6215.47 17445.48c-21.97,-4.66 -19.9,21.23 -45.59,11.66 -10.03,81.47 79.33,36.33 45.59,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8268.91 17526.84c33.99,12.17 29.47,-24.45 45.59,-34.83 -14.1,-60.09 -77.22,-16.24 -45.59,34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5868.69 17526.84c37.26,36.08 67.82,-16.79 72.98,-58.11 -29.64,-26.33 -82.49,-1.91 -72.98,58.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11088.98 17596.47c19.77,-19.51 45.76,-72.6 27.28,-104.46 -48.91,-66.36 -118.83,91.51 -27.28,104.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8971.64 17480.39c0,15.4 0,30.9 0,46.41 26.13,2.23 49.74,1.39 45.59,-34.84 -10.61,-9.78 -24.48,-15.28 -45.59,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4554.43 17596.47c-12.42,14.77 -12.42,54.77 0,69.55 22.72,1.83 28.23,-18.26 45.61,-23.13 -1.67,-32.71 -15.79,-49.46 -45.61,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8323.7 17666.02c3.75,28.04 -16.7,25.26 -9.2,58 21.96,26.54 55.21,2.09 73.07,-11.63 -13.45,-25.44 -24.2,-54.33 -63.87,-46.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8706.95 17689.25c-3.95,32.08 34.05,10.86 36.48,34.76 9.95,-2.79 6.25,-23.06 18.28,-23.18 -0.15,-31.75 -42.99,-27.5 -54.75,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8843.8 17724.02c-20.8,28.01 -1.5,70.25 9.2,92.9 24.37,-15.28 53.43,-24.86 45.58,-81.24 -27.88,8.39 -26.9,-19.95 -54.78,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8442.26 17735.68c26.18,40.25 55.42,76.66 109.54,81.24 0,-19.32 0,-38.68 0,-58 -35.98,-2.64 -69.32,-2.13 -109.54,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14465.76 17967.75c6.46,-38.24 14.62,-74.23 18.23,-116.07 -138.29,-270.43 -275.39,222.83 -18.23,116.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7009.46 18199.82c9.69,-43.44 -22.72,-33.1 -18.2,-69.65 88.76,-134.3 57.27,-378.73 -73.07,-348.15 -62.91,14.77 -121.18,196.66 -63.89,290.18 31.22,51.07 97.19,107.57 155.15,127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8780.02 17816.92c-2.45,68.79 27.22,96.79 63.78,116 30.13,-56.79 -11.02,-164.55 -63.78,-116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16729.06 17840.12c-4.5,69.55 47.2,96.61 91.26,69.66 16.89,-84.95 -57.76,-118.72 -91.26,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18189.3 17851.71c-7.12,43.74 11.11,55.43 9.11,92.8 48.32,23.69 71.4,18.81 118.65,0 -1.01,-79.41 -73.9,-153.51 -127.77,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8414.95 17886.54c-3.49,39.2 15.81,49.5 27.34,69.56 91.66,5.39 21.94,-158.5 -27.34,-69.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8177.65 17921.37c5.51,63.72 53.35,85.06 91.26,46.41 26.15,-113.95 -73.47,-110.14 -91.26,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12950.7 17898.05c-90.85,-35.79 -82.31,156.3 -9.08,150.91 59.78,-4.36 74.57,-125.06 9.08,-150.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5677.06 18037.38c55.1,177.96 356.87,94.08 237.21,-127.62 -114.47,-47.23 -205.84,7.62 -237.21,127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8734.34 18037.38c56.11,-294.63 -257.54,10.74 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10614.36 18107.04c22.68,38.97 78.99,48.84 91.28,46.41 117.46,-23.28 69.29,-270.68 -36.51,-243.7 -54.03,13.67 -114.29,94.84 -54.78,197.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7639.16 17921.37c-77.42,71.34 -28.28,242.71 63.87,139.21 -32.21,-50.67 31.32,-144.86 -63.87,-139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6799.53 18281.03c6.2,60.76 65.54,106.07 118.68,69.66 24.54,28.34 -18.92,83.12 9.08,116.04 12.2,0 24.37,0 36.57,0 3.51,-80.55 49.18,-107.57 45.61,-197.28 -15.63,0.54 -23.65,-8.7 -27.39,-23.21 -22.89,-2.03 -22.11,25.99 -36.51,34.78 -38.41,-1.46 -43.76,-45.01 -82.14,-46.37 -0.52,-123.2 -59.14,-172.43 -82.18,-266.91 -292.43,-135.9 -216.02,438.28 18.28,313.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4280.66 18037.38c-95.53,-219.03 -132.78,183.27 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12357.54 18002.58c2.6,18.66 -8.59,19.94 -9.1,34.79 3.95,67.31 63.14,84.17 100.4,46.37 7.15,-70.69 -40.29,-121.97 -91.29,-81.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10440.95 18002.58c-6,143.09 99.27,144.56 164.33,197.24 21.13,21.05 42.09,86.02 82.17,46.42 13.35,-75.09 -49.99,-52.58 -63.87,-92.8 -24.3,-92.07 -94.72,-177.34 -182.63,-150.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8825.61 18025.72c-7.36,8.07 -25.05,18.14 -27.39,0 -24.54,20.9 5.91,68.89 36.48,58.03 16.95,-20.57 -3.89,-33.83 -9.08,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14556.94 18037.38c-0.15,11.25 -11.11,9.05 -18.2,11.59 -3.75,47.36 9.34,73.14 45.61,69.65 19.7,-28.48 6.84,-85.79 -27.41,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6042.13 18118.62c1.24,40.88 40.91,33.04 63.81,46.38 81.17,-56.5 -47.2,-149.37 -63.81,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8433.15 18083.75c0,19.32 0,38.79 0,58.12 36.82,11.88 40.57,-18.14 54.75,-34.83 -0.98,-29.74 -30.56,-23.06 -54.75,-23.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7210.29 18083.75c-16.43,-1.46 -19.38,14.27 -36.56,11.59 5.51,24.02 14.1,43.96 45.67,34.84 3.83,-24.2 -6.25,-30.65 -9.11,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5448.85 18083.75c-6.25,54.63 -32.73,29 -27.39,81.25 19.29,186.8 243.33,-96.53 27.39,-81.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7730.42 18130.17c-16.35,-1.47 -19.21,14.26 -36.48,11.69 1.15,29.41 13.26,44.91 36.48,46.41 11.8,-15.28 11.8,-42.82 0,-58.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6306.7 18165c1.5,13.49 -1.99,20.71 -9.17,23.28 -7.7,52.32 21.36,57.82 27.38,92.75 54.27,10.93 81.41,-12.5 118.65,-23.24 12.52,-108.38 -74.65,-147.68 -136.87,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10723.89 18176.59c-16.66,39.92 6.52,59.02 27.39,81.21 62.23,-18.04 43.28,-129.42 -27.39,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8378.36 18327.46c24.54,-71.46 82.33,4.03 91.34,-58 -78.34,-43.08 -378.75,-198.76 -419.84,0 -50.43,243.58 314.55,316.62 328.5,58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7365.45 18246.25c1.44,13.45 -2.11,20.57 -9.2,23.21 4.26,36.88 39.49,22.95 45.67,0 -2.25,-20.46 -15.77,-26.4 -36.48,-23.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9099.38 18373.83c20.99,-164.21 -130.16,-133.56 -136.85,-46.37 -6.02,77.72 98.1,130.19 136.85,46.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5613.11 18269.45c-62.79,-10.27 -90.19,24.52 -82.09,104.37 20.26,16.8 44,29.22 82.09,23.28 31.49,-44.8 20.67,-73.4 0,-127.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8843.8 18281.03c-23.97,-3.48 -29.91,16.14 -27.39,46.42 23.96,3.3 39.33,-4.22 36.59,-34.84 -7.79,2.23 -8.59,-4.47 -9.2,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14903.83 18304.21c-4.27,36.4 7.82,51.81 36.48,46.49 28.41,-31.97 -11.33,-82.6 -36.48,-46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10486.62 18292.62c-26.21,1.5 -43.33,14.56 -36.48,58.07 16.35,-1.46 19.2,14.23 36.48,11.59 12.54,-14.84 12.54,-54.81 0,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9272.78 18304.21c-26.06,34.61 -11.62,82.49 18.29,104.46 26.78,-0.74 33.91,-26.55 45.58,-46.38 -5.99,-38.65 -23.38,-63.1 -63.87,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7082.47 18327.46c-59.05,155.85 -142.21,456.89 -45.58,580.22 47.17,-79.18 78.48,-178.65 82.09,-313.32 227.53,102.69 238.62,-387.09 -36.51,-266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8515.33 18339c-13.87,102.81 35.69,124.76 54.75,185.7 12.11,0 24.3,0 36.48,0 9.23,-61.67 -2.31,-248.72 -91.23,-185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6397.99 18327.46c-7.69,13.49 -12.02,31.09 -9.1,58.07 28.62,5.42 24.04,-31.32 45.58,-34.84 -2.16,-20.38 -15.71,-26.43 -36.48,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18545.22 18339c-7.61,13.49 -12.02,31.13 -9.1,58.11 27.22,-20.16 46.33,3.71 63.86,-11.58 -2.07,-36.08 -32.29,-36.22 -54.75,-46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8889.5 18339c-29.75,-2.98 -43.94,13.82 -45.69,46.53 16.46,-1.47 19.28,14.22 36.56,11.58 7.61,-13.49 12.05,-31.12 9.13,-58.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17815.05 18362.28c196.06,165.32 513.43,166.6 730.15,266.95 20.52,-69.04 -39.6,-55.87 -63.9,-69.69 -75.98,-43.08 -185.29,-61.56 -292,-104.46 -116.4,-46.63 -237.73,-146.1 -374.25,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11819.04 18397.11c-1.1,20.8 11.19,24.42 9.18,46.42 44.95,6.89 70.24,-11.19 63.89,-69.7 -21.8,-24.2 -66.11,-6.89 -73.07,23.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4034.21 18443.53c-12.34,118.02 120.09,107.31 136.96,34.79 3.26,-106.51 -114.38,-114.65 -136.96,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17541.36 18443.53c23.12,59.54 94.83,57.41 146.02,81.17 -5.69,-76.11 -110.29,-81.31 -146.02,-81.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9172.38 18431.94c-45,99.57 9.34,222.33 100.37,220.49 42.06,-98.62 13,-248.72 -100.37,-220.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8424.06 18431.94c-30.47,-11.69 -29.98,16.02 -27.36,46.38 -132.7,22.07 -106.97,252.28 0,266.9 101.1,13.82 174.9,-149.7 82.15,-255.21 -50.29,4.32 -72.57,-0.95 -54.79,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7383.66 18513.15c-19.98,1.68 -19.54,29.18 -18.22,57.96 18.54,-8.39 37.25,-34.94 18.22,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17294.85 18547.98c16.93,80.59 143.54,78.58 182.61,92.8 -18.62,-80.8 -135.02,-85.9 -182.61,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9875.14 18536.4c1.19,20.82 -11.18,24.52 -9.08,46.41 14.68,19.72 47,10.63 54.75,-11.7 1.36,-32.59 -22.37,-33.44 -45.67,-34.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8907.75 18536.4c-25.81,-9.69 -23.71,16.38 -45.67,11.58 0,15.51 0,30.87 0,46.38 11.67,15.84 43.16,15.84 54.78,0 2.91,-26.99 -1.49,-44.59 -9.1,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4627.43 18687.19c56.08,113.7 201.15,0.19 264.69,-46.41 -3.11,-205.65 -218.35,-35.16 -264.69,46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11298.89 18571.11c0,19.44 0,38.79 0,58.12 16.38,15.06 88.09,26.21 91.26,-11.69 -13.93,-47.67 -52.59,-59.47 -91.26,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7666.63 18571.11c-14.79,-3.18 -15.79,11.08 -27.48,11.7 -7.76,37.03 14.36,35.85 18.28,57.96 24.97,-0.22 21.63,-54.7 9.2,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10659.93 18594.36c-11.93,11.81 -33.56,11.37 -45.58,23.18 -6.79,35.74 25.05,22.39 18.28,58.07 10.52,-9.76 24.48,-15.29 45.61,-11.59 4.42,-36.52 -12.94,-45.43 -18.31,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16336.69 18896.1c-28.23,-35.13 18.22,-51.7 18.22,-81.32 0.06,-126.34 -114.32,-231.64 -219.05,-197.24 -119.97,146.8 55.05,367.47 200.83,278.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9464.5 18652.43c-4.18,36.22 19.46,37.07 45.59,34.75 7.92,-43.99 -30.34,-54.47 -45.59,-34.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8588.31 18652.43c0.4,35.27 -19.29,45.13 -27.34,69.55 15.31,76.26 101.38,106.84 136.87,34.84 2.6,-84.52 -43.51,-107.13 -109.53,-104.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9911.65 18675.61c5.07,20.67 4.67,48.21 18.28,57.96 24.05,3.59 23.53,-24.2 27.31,-46.38 -21.89,4.77 -19.81,-21.15 -45.59,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9391.43 18675.61c-22.46,-1.5 -43.94,-1.69 -54.79,11.58 0,15.47 0,30.98 0,46.38 20.39,26.94 35.64,-3.85 63.95,0 3.78,-27.9 -16.66,-25.19 -9.17,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5850.41 18675.61c0,15.47 0,30.9 0,46.37 23.87,3.3 39.24,-4.22 36.48,-34.79 -8.1,-9.05 -20.62,-12.42 -36.48,-11.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13379.75 18687.19c-16.46,-1.39 -19.29,14.19 -36.59,11.66 -4.24,36.3 7.92,51.81 36.59,46.38 11.59,-15.29 11.59,-42.75 0,-58.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7274.19 18698.85c-87.02,91 9.34,238.38 109.48,162.46 1.33,-21.67 6,-38.87 18.26,-46.53 -12.52,-76.96 -41.81,-132.39 -127.74,-115.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8131.98 18849.6c10.7,-1.8 16.26,2.64 18.28,11.7 24.89,8.39 18.37,-23.03 36.51,-23.25 1.75,-61.26 -67.06,-58.92 -54.79,11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6169.88 18791.64c-63.46,12.32 -92.1,68.6 -109.56,139.32 29.98,38.86 14.3,71.97 45.61,116.03 -63.49,64.13 13.67,158.71 45.64,162.46 106.97,12.42 59.89,-150.47 109.57,-197.28 12.54,-112.67 -18.72,-169.68 -82.18,-185.71 2.6,-18.7 -8.68,-19.94 -9.08,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6507.53 18849.6c13.01,17.86 47.49,11.37 45.59,-23.13 -13.61,-18.36 -52.02,-16.97 -45.59,23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8314.5 18826.47c-29.73,-2.96 -43.89,13.82 -45.59,46.5 11.62,15.84 43.07,15.84 54.79,0 3.86,-24.27 -6.26,-30.8 -9.2,-46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4216.76 18838.06c0,19.32 0,38.72 0,58.04 44.09,9.68 61.48,-14.64 63.9,-58.04 -17.21,-22.95 -43.08,-5.65 -63.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9044.62 18861.31c0,11.66 0,23.13 0,34.79 16.2,-2.64 45.76,11.69 36.51,-23.13 -8.11,-9.13 -20.57,-12.51 -36.51,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8706.95 18930.97c9.6,30.32 26.21,51.58 54.75,57.96 4.09,-10.3 8.05,-20.71 18.31,-23.28 0.49,-71.24 -49.37,-81.21 -73.07,-34.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19476.15 18907.68c-12.03,4.19 -14.39,20.39 -27.39,23.29 3.24,15.18 16.12,18.22 18.2,34.68 12.03,-4.03 14.36,-20.35 27.39,-23.13 -3.17,-15.29 -16.03,-18.26 -18.2,-34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9738.22 18919.27c-6.84,66.92 34.53,72.19 73.05,81.35 4.82,-60.86 -38.92,-107.06 -73.05,-81.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10486.62 18919.27c-21.22,-3.59 -35.07,1.91 -45.67,11.7 0,15.36 0,30.87 0,46.37 10.84,13.38 32.32,13.21 54.79,11.59 1.23,-28.56 1.41,-55.87 -9.11,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9911.65 19012.18c-24.56,0.73 -43.86,26.54 -27.33,46.41 23.99,3.49 23.5,-24.2 27.33,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4563.54 19151.34c57.18,116.92 228.04,125.94 264.69,-23.13 -31.14,-159.34 -249.5,-151.38 -264.69,23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5868.69 19047c-40.65,14.01 -93.53,12.61 -146.04,11.59 -120.32,288.14 185.72,344.52 146.04,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8989.84 19070.14c-45.24,3.08 -43.33,80.19 9.2,69.66 1.16,-28.67 1.33,-55.84 -9.2,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9893.42 19104.97c-45.23,3.08 -43.39,80.07 9.11,69.65 20.04,-24.45 1.93,-51.62 -9.11,-69.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10002.91 19209.46c-4.27,67.31 27.97,88.21 82.15,81.21 4.7,-32.78 22.06,-49.39 27.39,-81.21 33.91,-12.32 17.87,39.04 36.5,46.41 40.4,-1.72 -3.17,-64.67 -9.08,-81.25 -54.38,15.37 -101.38,-34.83 -136.95,34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6598.7 19163.05c-76.91,-5.1 -64.7,103.31 -82.06,173.99 70.61,2.79 98.18,-104.45 82.06,-173.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9254.53 19186.18c-21.45,-0.22 -26.87,20.09 -54.75,11.58 -4.88,52.69 13.44,75.82 54.75,69.66 22.73,-23.69 12.8,-47.48 0,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8862.08 19221.01c-32.33,127.84 29.32,201.02 146.07,174.15 49.16,-137.75 -58.65,-242.75 -146.07,-174.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7794.31 19221.01c-39.64,2.28 -16.63,20.2 -18.22,58.07 31.57,8.07 32.76,-40.77 18.22,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11691.32 19255.87c-12.2,0 -24.31,0 -36.51,0 -10.29,46.89 28.06,57.3 45.67,34.79 -4.84,-9.35 -9.54,-18.81 -9.17,-34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7173.73 19279.08c-72.23,141.34 81.08,278.42 155.13,162.49 28.8,-159.19 -66.47,-222.03 -155.13,-162.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9382.32 19302.26c-60.29,-11.37 -103.85,28.23 -91.25,116.03 31.71,220.53 288.73,-78.57 91.25,-116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13835.99 19348.63c-16.21,80.52 52.01,97.49 100.36,58.12 5.86,-87.85 -65.62,-115.42 -100.36,-58.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12266.29 19348.63c-45.28,3.08 -43.43,80.19 9.08,69.66 -3.75,-27.94 16.72,-25.15 9.11,-57.96 -10.53,1.8 -16.18,-2.64 -18.2,-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13388.84 19383.57c12.51,30.28 33.47,50.23 73,46.41 4.06,-10.41 7.99,-20.82 18.2,-23.24 -4.7,-40.47 -59.57,-17.02 -91.2,-23.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10586.96 19464.7c11.93,66.1 48.49,100.87 109.56,104.46 89.67,-107.97 -64.64,-232.3 -109.56,-104.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8332.8 19441.57c-15.19,0 -30.39,0 -45.58,0 -0.75,51.04 16.17,79.82 27.28,116 46.77,-8.58 16.55,-70.13 18.3,-116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11828.22 19511.19c-23.22,1.4 -35.41,16.9 -36.48,46.38 8.1,8.95 20.52,12.43 36.48,11.59 11.7,-15.29 11.7,-42.79 0,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6909.07 19580.75c38.08,5.94 61.81,-6.49 82.2,-23.18 -1.18,-75.27 -91.28,-45.2 -82.2,23.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6498.33 19580.75c21.14,3.7 35.09,-1.8 45.59,-11.59 -0.72,-34.5 -54.33,-31.13 -45.59,11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9418.83 19754.78c7.53,-48.43 53.66,-47.7 36.48,-127.66 -101.87,-119.23 -175.19,124.77 -36.48,127.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12083.74 19650.4c-1.82,56.57 48.44,46.72 91.28,46.38 33.16,-60.09 -85.26,-138.77 -91.28,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8332.8 19720.03c1.5,13.49 -2.01,20.61 -9.1,23.17 -4.33,63.58 27.64,81.03 63.87,92.91 18.05,96.83 70.06,150.65 118.68,208.83 80.56,-0.55 142.78,-16.76 191.63,-81.25 28.14,-198.53 4.09,-396.87 -200.82,-359.7 -42.07,54.78 -79.46,115.53 -164.24,116.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9008.15 19615.57c-19.15,-4.92 -24.25,7.95 -36.51,11.55 2.16,20.5 15.69,26.55 36.51,23.28 0,-11.58 0,-23.28 0,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M21100.68 19696.78c13.01,17.75 47.6,11.37 45.59,-23.13 -13.61,-18.36 -52.04,-16.97 -45.59,23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12686.13 19696.78c0,11.59 0,23.25 0,34.84 19.03,4.88 24.14,-7.97 36.48,-11.59 -2.24,-20.35 -15.68,-26.4 -36.48,-23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5476.24 19708.37c-13.27,21.96 -13.44,60.31 -36.59,69.62 22.4,85.83 99.04,45.46 91.38,-57.96 -10.78,-13.38 -32.32,-13.13 -54.79,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10368.06 19731.62c-21.19,-3.71 -35.1,1.9 -45.67,11.58 1.18,37.14 20.7,51.08 54.75,46.5 3.69,-27.95 -16.67,-25.26 -9.08,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8049.9 19731.62c-12.17,0 -24.37,0 -36.48,0 -1.01,28.89 -17.13,35.96 0,58.07 26.21,-1.62 43.33,-14.56 36.48,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9236.25 19789.69c-7.93,43.95 30.42,54.47 45.67,34.71 -8.36,-20.27 -17.04,-40.21 -45.67,-34.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11782.55 19812.83c-23.53,48.76 24.74,35.92 18.31,92.9 27.87,8.39 26.79,-20.05 54.75,-11.66 -1.82,-55.65 -20.01,-90.55 -73.07,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1916.9 20033.35c80.65,84.43 259.11,67.14 264.69,-69.66 7.93,-195.01 -293.26,-201.49 -264.69,69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5768.32 19824.4c-33.91,1.84 -60.04,54.6 -36.56,92.91 19.61,-21.45 43.82,-37.07 36.56,-92.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17267.52 19963.69c-5.74,141.85 42.27,276.4 109.48,359.74 32.73,-47.33 87.6,-66.58 136.96,-92.87 18.02,-62.03 31.06,-130.73 63.87,-174.04 -42.59,-114.69 -225.89,-203.34 -310.31,-92.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10495.73 19905.73c-6.03,0 -12.11,0 -18.31,0 1.75,9.79 -3.49,10.93 -9.08,11.59 0,7.74 0,15.5 0,23.24 7.76,-2.23 8.68,4.48 9.08,11.59 6.2,0 12.28,0 18.31,0 -1.67,-9.87 3.6,-10.96 9.17,-11.59 0,-7.74 0,-15.5 0,-23.24 -7.76,2.13 -8.68,-4.55 -9.17,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17066.75 19928.9c-23.63,14.95 -28.66,23.97 -18.31,58.07 21.22,3.7 35.1,-1.95 45.7,-11.7 8.02,-37.13 -23.65,-24.08 -27.39,-46.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10696.52 19998.52c-9.11,0 -18.28,0 -27.39,0 0,15.5 0,31.02 0,46.41 19.03,4.88 24.22,-7.95 36.51,-11.59 -4.88,-9.31 -9.51,-18.87 -9.11,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8916.86 20044.94c4.01,37.39 13.96,67.43 54.79,58.07 31.06,-57.01 -26.12,-110.21 -54.79,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7456.65 20033.35c-15.97,10.64 -31.75,21.6 -27.34,58 28.26,1.91 41.01,-40.77 27.34,-58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17021.17 20056.52c-9.64,81.83 23.01,109.99 82.05,104.46 9.2,-15.41 15.12,-35.01 27.39,-46.38 -11.44,-47.04 -61.53,-94.81 -109.45,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8360.06 20277.06c14.88,17.37 67.41,17.37 82.2,0 61.1,-160.56 -131.51,-124.88 -82.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10221.93 20207.5c-21.29,3.71 -37.65,13.89 -54.7,23.06 -34.22,8.77 -19.87,-44.33 -45.67,-46.34 -229.1,-56.86 -410.56,138.36 -374.17,382.91 36.25,243.67 350.88,422.76 501.94,243.67 -16.38,-127.66 38.06,-258.44 27.39,-382.88 -26.74,-63.61 -74.42,-133.15 -54.79,-220.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15953.32 20184.22c-11.93,4.03 -14.35,20.49 -27.39,23.28 2.16,20.27 15.72,26.4 36.51,23.06 3.83,-24.13 -6.28,-30.72 -9.11,-46.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10568.8 20207.5c-4.27,36.08 19.46,37.03 45.58,34.72 0,-11.66 0,-23.13 0,-34.72 -11.93,-14.96 -33.65,-14.96 -45.58,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8834.69 20195.81c-36.74,-11.37 -36.74,69.44 0,57.96 17.12,-22.07 1.1,-29.07 0,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14785.19 20497.62c-2.94,-42.38 24.53,-46.09 45.58,-58.12 21.14,-198.2 -207.17,-312.99 -228.13,-127.59 -11.44,101.2 58.19,203.63 182.55,185.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16911.6 20230.6c-63.9,-16.17 -101.61,24.6 -109.48,69.74 -25.15,144.6 181.04,258.62 209.94,104.34 17.85,-95.44 -47.78,-160.74 -100.46,-174.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10294.99 20311.88c-12.2,0 -24.28,0 -36.51,0 7.09,10.41 9.77,26.21 9.11,46.38 24.04,3.52 29.96,-16.02 27.39,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9327.54 20335.09c-7.59,13.49 -12.03,31.13 -9.09,58 21.97,-4.7 19.88,21.22 45.59,11.55 -1.41,-13.46 2.03,-20.57 9.2,-23.21 -1.7,-32.52 -15.86,-49.27 -45.69,-46.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18006.79 20358.3c1.06,29.51 13.24,45.03 36.48,46.38 24.71,-27.28 -15.05,-77.8 -36.48,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13498.31 20462.78c4.58,30.47 29.64,65.41 54.75,34.84 -5.33,-29.55 -33.07,-61.15 -54.75,-34.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17057.65 20497.62c0.43,34.79 64.79,33.61 54.78,-11.59 -19.2,-25.48 -40.6,-2.53 -54.78,11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10632.64 20497.62c-38.06,-5.87 -43.84,29.29 -45.67,69.55 17.38,4.95 22.98,25.04 45.67,23.21 18.13,-22.8 5.76,-66.22 0,-92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10888.15 20601.92c-19.02,171.8 134.95,218.52 191.72,104.49 9.17,-153.65 -135.61,-228.48 -191.72,-104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13972.89 20543.99c-17.97,9.24 -32.73,40.66 -18.2,57.97 31.63,8.17 32.7,-40.55 18.2,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11335.3 20625.2c19.87,82.49 57.18,124.88 136.93,104.5 15.77,-26.33 22.06,-64.86 18.31,-116.04 -40.02,-61.26 -120.09,-47.99 -155.24,11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16190.56 20590.37c16.53,17.75 28.05,41.83 63.98,34.83 -1.5,-13.49 1.98,-20.57 9.11,-23.24 -8.62,-45.2 -46.03,-9.75 -73.1,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12640.46 20590.37c-2.19,39.09 33.88,59.91 54.75,34.83 -5.68,-49.05 -20.27,-42.68 -54.75,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12010.68 20636.9c-11.94,11.81 -33.56,11.25 -45.59,23.13 -28.49,108.63 76.24,100.56 109.57,92.83 -4.19,-60.45 -55.54,-60.86 -63.98,-115.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7693.94 20636.9c-35.15,-9.24 -35.15,55.51 0,46.27 0,-15.37 0,-30.87 0,-46.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9336.65 20671.58c-15.02,38.57 8.95,65.63 9.2,116.15 52.25,8.51 68.97,-28.34 91.26,-58.07 -7.53,-65.3 -56.46,-100.97 -100.46,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5923.39 20741.24c36.82,-3.52 65.72,-17.12 63.95,-69.66 -37.39,-41.06 -99.27,18.26 -63.95,69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16929.88 20706.41c4.76,44.25 32.58,59.25 73.07,58.07 13.21,-74.13 -58.62,-120.62 -73.07,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11116.26 20683.13c0,15.62 0,31.06 0,46.53 26.72,-2.96 28.08,26.21 54.87,23.18 7.78,-9.24 5.42,-31.9 18.22,-34.84 -9.63,-29.51 -46.85,-62.32 -73.09,-34.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12056.35 20787.77c11.96,32.81 47.95,19.72 82.17,46.27 26.15,-53.27 -70.04,-65.81 -82.17,-46.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8652.17 20799.35c-11.79,51.52 39.73,87.08 45.67,11.48 -10.61,-9.57 -24.45,-15.22 -45.67,-11.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4444.97 20857.28c31.46,9.24 38.5,-12.86 54.7,-23.28 -3.58,-38.94 -70.64,-31.09 -54.7,23.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3787.86 20938.6c19.03,-115.08 -114.33,-112.85 -136.88,-46.49 0.44,101.37 99.88,110.43 136.88,46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19530.9 20868.87c-7.32,47.99 13.96,59.65 45.59,58.07 -1.16,-20.83 11.21,-24.52 9.11,-46.53 -23.71,-14.73 -27.54,-25.37 -54.7,-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10285.91 20996.49c29.35,-2.45 38.54,20.58 72.97,11.66 89.07,-141.95 -131.88,-194.09 -72.97,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10057.69 20950.19c-31.83,9.85 -34.07,57.11 -45.61,92.8 62.05,94.29 144.97,-83.12 45.61,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7155.53 20973.32c-23.87,-3.27 -39.24,4.14 -36.56,34.83 15.69,20.94 35.87,-3.48 36.56,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9008.15 21147.36c-20.56,-5.31 -28.14,63.06 -9.11,69.63 33.56,10.74 16.53,-61.24 9.11,-69.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4700.45 21205.43c9.43,50.56 56.34,30.58 82.15,11.56 0,-15.48 0,-30.88 0,-46.38 -37.57,-27.21 -68.14,-0.44 -82.15,34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19549.13 21228.68c-6.43,58.4 18.94,76.44 63.87,69.55 6.17,-63.17 -32.15,-87.63 -63.87,-69.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17778.57 21251.81c1.49,13.49 -2.03,20.71 -9.11,23.17 5.1,43.86 28.54,64.35 63.87,69.74 47.2,-41.28 -1.82,-146.51 -54.75,-92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11362.69 21344.71c20.39,16.68 44.06,29.12 82.15,23.18 63.95,-101.19 -95.84,-187.09 -82.15,-23.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15862.06 21565.17c-28.23,-2.01 -41.03,40.84 -27.41,58.03 28.57,5.21 29.23,-24.81 27.41,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8031.62 21588.38c-3.84,24.23 6.25,30.72 9.1,46.41 7.33,-6.26 14.89,-12.1 27.46,-11.59 -7.99,-16.97 -13.67,-36.84 -36.56,-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14775.98 21716.04c4.5,75.56 45.16,105.07 100.46,115.93 84.34,-89.39 -47.2,-241.76 -100.46,-115.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12841.23 21692.76c-24.05,-3.37 -29.96,16.06 -27.36,46.52 9.11,0 18.2,0 27.36,0 0,-15.5 0,-30.9 0,-46.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7018.58 21750.87c2.85,42.24 -1.5,75.46 -9.08,104.38 69.69,3.59 111.96,-27.76 109.48,-115.97 -37.28,-25.37 -73.18,-27.28 -100.4,11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16190.56 21762.42c8.04,17.09 13.7,36.85 36.59,34.94 4.84,-9.34 9.51,-19.02 9.11,-34.94 -11.97,-14.95 -33.59,-14.95 -45.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9847.75 21878.46c-9.59,36.33 -3.26,57.56 -9.08,116.08 -1.18,25.56 -38.75,4.88 -54.78,11.59 -14.86,37.47 -4.35,62.95 0,104.45 80.64,17.42 81.74,135.88 127.76,197.28 129.83,37.58 216.34,-4.76 301.2,-69.55 -13.06,-63.5 38.31,-123.37 54.75,-185.81 -18.28,-277.65 -286.98,-383.93 -419.85,-174.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6644.38 21774c-24.2,0.22 -52.08,-4.36 -63.87,11.66 -6.61,35.45 15.77,34.1 9.11,69.59 15.27,0 30.47,0 45.58,0 3.35,-41.65 24.54,-42.5 9.18,-81.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7748.73 21924.87c-36.59,12.73 -11.88,83.66 27.36,69.66 -1.16,-20.71 11.21,-24.53 9.11,-46.41 -5.6,-16.14 -35.07,-1.8 -36.48,-23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11481.4 21959.78c-34.97,47.88 -26.35,129.74 27.39,150.79 46.69,-10.82 51.48,-81.02 36.51,-139.31 -21.45,-3.59 -34.22,-18.23 -63.9,-11.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11426.65 22064.16c-58.21,-20.49 -78.16,-82.38 -118.64,-81.31 -127.67,3.96 -130.36,340.6 45.59,301.73 74.04,-16.24 94.92,-120.15 73.05,-220.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8104.68 21994.54c-2.57,30.36 3.34,50 27.3,46.38 9.37,-32.6 10.44,-49.46 -27.3,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18974.16 22075.74c-23.3,1.28 -18.02,38.97 -18.2,69.66 21.28,3.59 37.65,22.58 54.69,0 0,-7.78 0,-15.51 0,-23.28 6.75,-39.49 -33.58,-19.1 -36.5,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9254.53 22110.57c-40.74,17.42 -67.64,96.53 -36.51,139.28 58.04,17.86 81.6,-87.37 36.51,-139.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13096.75 22168.54c-2.75,57.89 12.51,92.36 63.89,81.31 37,-66.65 -25.92,-138.73 -63.89,-81.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20379.61 22261.34c-14.67,-3.15 -15.71,11.03 -27.38,11.66 5.19,47.58 47.69,47.8 63.86,81.24 19.73,-9.75 32.33,-28.56 27.39,-69.66 -42.06,-24.2 -49.19,36.01 -63.87,-23.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10796.9 22284.57c-30.65,-7.95 -33.42,19.54 -36.51,46.41 28.54,5.54 40.74,-9.97 36.51,-46.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20972.84 22307.85c-1.19,28.68 -1.36,55.84 9.2,69.66 43.56,9.02 53.92,-24.23 54.75,-69.66 -17.28,-23.06 -43.17,-5.61 -63.95,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9108.49 22481.97c-55.45,93.67 43.86,193.14 100.45,116.03 16.7,-102.55 -23.96,-132.09 -100.45,-116.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6671.77 22539.93c-129.09,-159.78 -304.95,13.38 -282.89,220.53 8.68,81.87 92.93,192.63 136.84,197.28 129.26,13.68 195,-243.37 146.05,-417.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8451.46 22690.92c-49.76,-21.67 -55.79,50.88 -36.51,81.14 34.92,-6.27 49.55,-45.24 36.51,-81.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9309.32 24106.66c58.19,-55.54 105.21,-77.5 109.48,-162.56 1.99,-39.6 -39.59,-86.93 -36.5,-139.17 6.68,-112.27 104.55,-121.8 164.26,-197.4 35.46,-44.91 91.74,-183.46 109.53,-255.24 45.54,-183.91 -10.66,-323.81 -91.25,-487.44 -37.69,9.24 -56.8,-5.1 -63.9,-34.72 -111.73,-69.22 -278.04,-1.4 -355.95,127.62 16.7,75.38 -34.91,111.05 -45.61,162.46 -56.08,268.63 124.99,482.11 182.54,731.09 -30.13,74.43 -9.6,181.05 27.39,255.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16719.98 22922.92c7.84,55.73 42.84,76.99 72.97,104.37 17.44,-4.98 16.53,-33.15 45.67,-23.13 -9.51,-90.89 -66.95,-125.53 -118.64,-81.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10176.34 22934.47c-6.78,45.68 -19.03,84.1 -27.39,127.66 33.51,75.66 160.4,87.37 182.54,0 23.71,-93.35 -69.4,-191.75 -155.15,-127.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11791.74 22969.34c-12.03,4.03 -14.45,20.46 -27.39,23.13 -2.08,41.39 13.12,60.75 45.61,58.07 22.64,-30.17 1.91,-70.61 -18.22,-81.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5969.06 23027.3c-12.68,33.84 -22.72,57.53 0,81.32 25.72,-6.05 38.72,-28.16 63.87,-34.83 -13.35,-25.48 -24.22,-54.34 -63.87,-46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1944.3 23027.3c-15.19,0 -30.39,0 -45.61,0 -1.24,28.64 -1.42,56.03 9.02,69.74 21.63,-11.22 44.92,-20.39 36.59,-69.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M5193.32 23085.34c-28.2,-2.01 -41.06,40.91 -27.39,58 25.64,1.83 26.33,-28.46 27.39,-58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7164.61 23155.03c-19.03,-4.92 -24.1,7.95 -36.48,11.55 -3.91,24.31 6.17,30.8 9.08,46.42 28.58,5.27 29.16,-24.75 27.39,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18910.29 23526.29c38.9,-165.73 -129.11,-415.99 -246.41,-301.64 -112.39,109.48 62.2,432.15 246.41,301.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12229.78 23224.65c-4.27,36.22 7.93,51.81 36.51,46.42 6.25,-38.98 -15.28,-42.5 -36.51,-46.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17605.2 23294.24c-45.24,3.08 -43.4,80.19 9.11,69.66 15.04,-18.04 -3.09,-45.24 -9.11,-69.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12613.06 23433.38c-19.9,1.84 -19.64,29.33 -18.2,58.22 10.5,-9.87 24.37,-15.4 45.59,-11.69 8.02,-37.29 -23.65,-24.09 -27.39,-46.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17796.85 23468.25c-13.53,9.87 -19.61,29.29 -18.28,58.04 18.2,0.15 11.67,31.67 36.48,23.28 4.09,-10.42 8.1,-20.83 18.28,-23.28 3.86,-39.67 -27.28,-34.91 -36.48,-58.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12275.37 23503.14c-28.46,-5.27 -29.13,24.75 -27.28,57.97 25.63,1.72 26.3,-28.45 27.28,-57.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7830.88 23572.7c-7.67,13.49 -12.11,31.23 -9.2,58.11 32.84,22.52 33.5,-4.51 63.97,-11.59 -8.01,-28.67 -21.31,-50.34 -54.78,-46.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6379.69 23700.44c-6.61,31.63 18.13,23.35 18.3,46.37 32.73,6.82 44.18,-13.49 63.87,-23.24 5.42,-99.29 -71.48,-101.49 -82.17,-23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M2300.25 23677.19c-17.97,-5.53 -29.47,53.27 -9.2,57.96 32.89,11.15 16.2,-50 9.2,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10139.86 23990.62c53.17,-72.63 20.5,-250.48 -82.18,-208.94 -53.19,77.91 -8.76,212.76 82.18,208.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8268.91 23769.99c3.78,28.04 -16.67,25.26 -9.17,58.07 10.61,-1.8 16.29,2.57 18.28,11.66 25.63,-2.2 38.92,-20.28 36.48,-58.04 -21.94,4.77 -19.78,-21.27 -45.59,-11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13863.38 23828.06c-42.59,4.98 -23.56,68.7 18.19,57.96 7.85,-36.91 -14.27,-35.89 -18.19,-57.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16856.82 23862.78c-11.59,51.17 23.07,74.02 45.7,46.49 -7.27,-25.48 -18.31,-46.38 -45.7,-46.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9044.62 23874.47c-35.15,-9.17 -35.15,55.51 0,46.38 15.19,-22.91 -0.84,-14.64 0,-46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19293.63 23955.68c18.02,108.85 127.07,164.8 200.74,104.49 37.92,-151.09 -157.58,-210.23 -200.74,-104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9893.42 23944.09c-27.71,3.63 -37.05,65.52 -18.28,92.8 12.2,0 24.4,0 36.51,0 3.49,-53.83 15.2,-71.75 -18.23,-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18088.85 24060.17c-34.66,8.47 -32.56,71.24 18.28,58.07 7.87,-37.06 -14.36,-36.01 -18.28,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7091.61 24060.17c-17.88,37.58 -58.62,68.16 -63.95,127.59 -7.44,84.51 53.77,205.02 91.28,208.98 118.97,12.32 187.68,-377.77 -27.33,-336.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4700.45 24060.17c-55.45,6.79 -83.68,48.29 -72.98,139.18 38.32,-13.06 59.11,-48.51 91.26,-69.56 -3,-27.16 -10.96,-47.95 -18.28,-69.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3148.99 24199.35c-37.25,6.82 -76.75,10.74 -72.97,69.77 29.9,18.77 34.89,-2.75 72.97,0 2.75,-27.16 17.88,-47.99 0,-69.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14556.94 24338.63c10.61,9.68 24.48,15.28 45.69,11.59 -1.15,-20.83 11.19,-24.42 9.11,-46.38 -20.82,-25.19 -56.88,-4.14 -54.81,34.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19649.49 24315.42c-34.56,-10.08 -42.84,38.49 -27.41,58.03 28.57,5.36 29.23,-24.74 27.41,-58.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M3742.28 24570.74c-37.6,-11.55 -43.59,47.7 -27.39,69.56 32.64,6.82 27.71,-34.28 27.39,-69.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17240.16 24617.15c3.43,49.9 32.38,67.21 82.15,58.07 2.42,-75.37 -33.39,-71.56 -82.15,-58.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14794.27 24860.93c119.33,-116.82 -96.05,-347.61 -127.77,-174.12 -14.01,77.06 30.73,164.66 127.77,174.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8560.97 24698.48c-23.3,1.28 -35.41,16.9 -36.56,46.31 22.03,-4.8 19.9,21.22 45.67,11.58 3.78,-27.86 -16.69,-25.18 -9.11,-57.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14967.67 24860.93c-7.92,60.31 14.36,82.27 54.79,81.14 -2.77,-46.75 -13.44,-83.48 -54.79,-81.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M17021.17 24918.89c-2.63,30.4 3.31,49.9 27.27,46.38 4.88,-9.24 9.64,-18.88 9.21,-34.79 -8.11,-9.06 -20.62,-12.43 -36.48,-11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14839.94 25232.22c-16.35,-1.47 -19.29,14.22 -36.51,11.58 -3.72,51.3 20.73,66.48 36.51,92.8 33.24,-8.5 18.05,-91.44 0,-104.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15223.2 25255.5c-18.23,0 -36.51,0 -54.79,0 -15.86,38.82 -5.33,74.1 18.28,92.75 37.08,-5.72 55.19,-48.5 36.51,-92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13233.59 25278.64c-21.94,-4.8 -19.78,21.12 -45.59,11.66 1.93,59.36 21.32,96.75 72.98,92.8 18.13,-43.64 -9.03,-74.83 -27.39,-104.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7228.51 25290.3c0.75,16.46 1.47,32.81 -9.11,34.83 10.78,46.31 76.73,19.54 63.87,-34.83 -16.26,-21.67 -23.22,9.46 -54.75,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14237.58 25383.09c-19.06,-4.89 -24.14,7.99 -36.51,11.58 -6.35,42.9 14.45,51.3 45.67,46.53 3.7,-28.08 -16.69,-25.37 -9.17,-58.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10824.29 25649.92c-12.2,146.17 33.07,191.23 72.97,290.18 27.97,8.36 26.87,-20.09 54.75,-11.59 81.17,-119.89 3.26,-402.74 -127.73,-278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M16792.95 25800.9c51.36,-76.04 -18.45,-209.38 -82.17,-139.31 -16.44,71.68 7.87,149.18 82.17,139.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M9053.74 25649.92c-23.99,-3.52 -29.91,16.13 -27.34,46.53 23.82,3.15 39.27,-4.29 36.42,-34.87 -7.67,2.27 -8.54,-4.55 -9.08,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11262.3 26021.43c-24.04,-3.63 -23.53,24.08 -27.36,46.27 24.63,-0.73 43.91,-26.55 27.36,-46.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M429.35 11109.36c49.02,60.6 70.25,208.32 155.16,185.7 0.74,-128.57 -102.71,-124.65 -155.16,-185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M6635.2 16621.63c-19.38,19.1 39.01,81.79 54.87,58 10.01,-55.33 -54.43,-15.95 -54.87,-58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13735.61 11782.54c-15.63,0.44 -23.61,-8.69 -27.39,-23.25 -53.11,91.12 -162.48,110.62 -191.63,232.12 151.29,17.82 232.22,-153.1 355.87,-208.87 4.44,-141.12 -122.81,-84.51 -136.85,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4800.9 14405.12c-5.1,72.19 -0.67,132.42 36.46,150.87 52.2,0.54 74.75,-36.52 91.26,-81.21 87.94,50.63 165.59,114.35 146.05,301.77 112.31,185.88 239.26,353.32 219.05,707.74 92.58,56.28 130.49,182.19 191.63,278.61 -11.36,159.45 23.27,377.78 -18.23,498.91 -28.72,-137.93 -143.68,-194.93 -246.38,-174 -55.62,65.59 -53.28,194.83 -127.85,220.39 -32.5,11.25 -47.92,-50.3 -82.09,0 -28.72,-67.82 -47.75,-148.19 -146.05,-127.59 -8.94,111.9 2.68,197.69 100.37,174.12 18.94,2.96 2.51,50.95 18.28,57.96 129,-5.39 252.84,23.25 346.87,0 -14.45,51.29 -41.09,87.04 -73.07,116.08 -37.83,13.28 -35.58,-24.45 -63.9,-23.28 -36.25,0.44 -37.82,44.91 -54.75,69.66 0.09,23.13 24.89,14.77 18.2,46.49 157.49,-1.46 378.67,43.96 483.74,-69.62 68.97,67.09 117.95,159.34 173.41,243.67 1.75,44.8 -42.33,31.23 -36.57,81.21 26.3,138.88 156.16,49.49 228.19,23.28 61.96,37.25 143.22,49.9 209.94,81.21 11.19,-52.88 -25.05,-45.54 -18.31,-92.91 98.87,-76.66 249.93,-129.23 337.79,-11.58 -4.76,75.27 -59.81,86.52 -45.67,185.7 -17.53,21.44 -42.76,-45.65 -91.26,-23.25 -8.18,20.61 -22.06,33.88 -27.39,58.07 4.76,55.88 54.61,54.26 82.15,81.25 40.25,0.85 26.24,-67.21 82.18,-46.41 7.18,-40.15 -10.18,-49.02 -18.28,-69.66 57.67,-11.47 32.47,82.42 63.87,104.37 63.63,11.37 77.32,-40.87 146.04,-23.13 17.13,-59.46 38.9,-113 91.26,-127.62 27.48,-155.67 -89.27,-141.19 -136.93,-81.35 -20.7,-12.28 -3.43,-72.92 -9.11,-104.34 -34.48,16.76 -17.53,-31.86 -45.64,-23.25 -23.15,28.34 19.29,24.71 9.08,69.63 -56.69,-43.93 -167.26,-119.85 -200.74,-232.12 4.53,-93.27 143.27,-22.7 164.23,-34.79 -40.31,-111.16 -186,-88.36 -182.46,-255.24 89.1,-87.81 116.92,-253.64 164.27,-394.57 -58.45,6.92 -70.48,72.73 -91.26,127.65 -37.86,-40.25 -12.19,-53.52 -9.11,-116.08 -10.61,-9.64 -24.48,-15.4 -45.67,-11.58 -31.98,-90.85 53.38,-112.45 63.87,-185.71 -63.35,-7.07 -60.78,69.66 -109.46,81.25 -47.69,-32.27 -170,-44.69 -173.43,46.41 -37.34,11.33 -36.9,-1.28 -82.15,0 17.76,-101.19 74.28,-153.1 63.84,-290.08 57.55,-74.02 99.13,-167.95 155.27,-243.7 -6.78,-40.22 -28.08,-61.88 -9.22,-104.46 -56.75,-2.01 -100.78,-28.45 -109.46,46.28 11.68,16.13 39.59,11.58 63.81,11.8 -28.08,41.51 -41,102.44 -109.48,92.72 -16.55,-81.02 -100.2,-133.49 -182.54,-92.72 31.98,108.94 98.3,127.34 100.4,255.25 -110.98,19.54 -278.91,185.37 -383.28,23.13 0.66,-57.12 4.42,-110.4 45.67,-116.04 25.81,5.84 34.83,33.04 45.59,58.07 41.66,-4.98 100.54,11.78 127.76,-11.58 17.53,-90.97 -42.5,-155.13 -136.87,-139.28 -38.06,-36.74 -70.79,-80.19 -136.93,-81.35 -10.18,-55.4 28.41,-48.84 18.28,-104.38 -29.38,2.57 -38.64,-20.46 -73.03,-11.55 -24.65,-38.14 -37.25,-135.03 -9.11,-174.15 -21.8,-88.21 -66.46,-147.54 -109.53,-208.69 25.28,-35.16 65.79,8.48 82.14,23.13 122.92,-12.03 219.46,-148.45 155.16,-325.01 -10.62,-9.69 -24.48,-15.29 -45.62,-11.56 -21.45,-98.77 62.05,-168.61 18.2,-220.45 -64.53,49.38 -21.77,235.3 -100.34,266.83 -103.36,7.62 -141.45,-67.65 -237.21,-69.55 -9.89,30.07 -22.23,56.94 -18.36,104.37 -44.12,-76.33 -107.06,-104.56 -155.1,-150.76 30.83,-68.48 -7.06,-195.93 -27.39,-232.22 12.03,21.67 -68.7,-83.44 -63.95,-81.21 -222.93,-104.49 -171.68,236.11 -301.07,290.15zm666.22 371.47c-30.88,-0.15 -74.39,-43.99 -45.67,-81.35 8.62,35.49 44.43,36.34 45.67,81.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8862.08 14057.01c-80.48,-34.21 -9.92,-153.66 -18.28,-220.53 -16.12,-10.42 -26.65,-27.94 -45.59,-34.72 -45.76,-4.14 -44.75,51.26 -82.18,57.86 -55.7,-2.57 -49.36,-84.07 -91.26,-104.38 -34.56,24.53 -56.95,-4.44 -100.36,0 -12.19,-61.88 -17.13,-132.94 -91.26,-116.03 -23.78,39.38 -41.34,86.64 -45.61,150.87 -23.71,12.42 -44.75,28.23 -82.15,23.28 -49.94,-38.46 8.15,-171.92 -82.18,-174.15 -31.66,21.73 -32.73,82.2 -45.59,127.74 -51.35,-23.69 -54.92,-108.09 -136.92,-92.91 -18.72,84.51 -35.67,171.26 -100.37,197.28 -39.1,7.08 -37.25,-37.8 -72.97,-34.83 -48.7,49.9 -105.22,15.36 -155.16,34.83 -36.33,14.11 -42.32,62.41 -73.07,81.21 -47.2,28.78 -93.33,-9.34 -136.84,34.84 -3.86,95.13 -97.97,203.84 -27.42,324.91 39.36,19.62 76.67,41.83 100.41,81.32 -1.27,40.88 -26.07,51.8 -27.39,92.79 -129.44,58.82 -459.87,32.78 -310.28,255.25 53.58,-26.65 139,-22.51 173.43,34.94 -1.1,52.61 -61.81,29.63 -45.61,104.34 -68.97,6.38 -111.56,-20.68 -146.05,-58.07 -47.43,13.16 -61.7,68.6 -127.76,58.07 -37.05,-34.06 -39.33,-112.41 -82.15,-139.28 -87.34,12.73 -146.9,60.93 -200.82,116.03 -14.36,188.27 130.85,272.16 246.41,220.53 20.44,4.99 3.75,57.23 9.17,81.21 119.17,30.25 121.91,208.54 173.38,324.91 48.09,-4.58 115.27,14.96 136.93,-23.13 -53.2,-99.61 82.4,-179.24 18.19,-290.18 20.96,-50.63 106.4,-19.43 136.96,-57.96 60.96,97.96 -37.43,180.93 -73.07,232.07 -20.47,75.82 27.28,101.64 -9.02,150.91 -23.74,-12.54 8.68,-96.31 -36.57,-81.32 -36.41,-7.59 -26.15,44.15 -27.39,81.32 -106.48,-19.98 -114.06,136.6 -91.28,243.67 -9.11,15.47 -24.63,22.68 -27.36,46.37 -52.36,-19.1 -160.58,-99.06 -182.54,11.7 -50.12,-15.41 -74.83,-4.99 -100.37,34.83 62.2,84.4 -51.17,79.92 -45.67,162.34 22.37,9.31 52.68,19.95 54.87,-23.18 36.88,57.78 137.19,166.49 200.71,81.25 44.58,49.35 -89.01,112.12 -54.78,185.7 43.76,38.09 80.99,-16.46 100.4,-46.41 31.11,17.53 35.15,99.73 9.08,127.52 37.34,21.48 127.93,46.53 173.43,92.9 -27.13,81.54 -127.41,70.1 -118.64,197.28 33.96,22.62 88.17,19.44 91.25,81.35 49.19,-30.94 94.37,10.49 118.65,46.38 67.73,-10.74 131.11,-26.77 164.35,-81.35 44.44,28.23 108.71,27.94 155.13,0 3.34,152.48 -63.69,233.17 -27.39,394.68 29.67,0.91 56.11,5.94 73,23.13 -23.73,43.44 -102.64,16.57 -82.17,116.08 8.18,5.17 16.38,10.15 18.28,23.13 92.7,-29 140.04,-115.97 209.94,-174.05 18.92,2.98 2.47,50.97 18.2,58.07 33.56,-76.22 54.43,-232.18 36.56,-348.11 10.78,-28.78 55.88,-14.04 45.59,-69.66 177.36,6.57 184.36,229.77 328.58,278.49 1.33,44.25 -23.04,55.94 -27.39,92.91 -106.71,-19.03 -148.15,13.15 -237.3,34.83 21.8,49.57 35.64,109.33 36.48,185.55 25.46,37.32 70.07,50.27 91.26,92.84 56.72,-50.64 126.69,-117.55 191.74,-92.84 13.01,-50.41 -31.22,-53.38 -9.2,-81.17 94.78,114.94 299.78,38.09 310.39,-127.66 70.61,115.23 148.78,220.75 246.33,301.67 0,27.16 0,54.22 0,81.21 13.52,21.56 47.17,17.41 45.64,58.07 -17.28,20.49 -58.45,10.85 -72.98,34.83 -23.27,77.62 6.95,141.63 54.73,162.46 -0.13,23.02 -24.89,14.73 -18.31,46.37 -70.64,-26.39 -128.92,28.05 -136.85,81.25 -15.45,104.15 101.78,183.17 164.33,208.94 14.94,-18.04 3.83,-54.12 -9.17,-69.63 26.55,-28.16 54.66,-54.25 63.86,-104.49 40.83,52.54 21.45,181.67 91.26,197.28 -8.16,24.31 -51.43,4.11 -54.69,34.79 8.45,54.99 19.46,106.84 72.97,104.49 19.46,5.43 17.39,-16.57 18.23,-34.83 54.09,12.54 82.84,57.23 100.46,116.03 50.48,55.77 144.76,55.77 173.35,139.32 238.05,78.68 396.46,28.34 647.94,69.66 22.96,-96.21 40.6,-139.21 36.56,-255.36 29.19,-28.68 65.91,-47.77 82.1,-92.8 49.45,-8.29 71.22,65.92 118.64,23.13 -9.17,-54 -56.1,-60.2 -109.45,-57.96 78.25,-218.23 -4.76,-490.3 -109.54,-638.35 -8.18,-136.53 -87.19,-183.02 -155.15,-243.67 -5.54,-43.33 -19.29,-76 -36.48,-104.34 -26.74,-10.52 -28.08,-10.52 -54.82,0 -63.12,-114.46 -190.04,-98.84 -273.77,-127.73 25.55,-53.42 10.26,-89.1 0,-150.91 -33.82,-7.22 -53.46,-32.59 -82.09,-46.37 15.68,-55.62 32.81,-11.99 72.97,-11.59 15.86,-53.42 47.7,-86.42 36.51,-174.12 -68.39,-74.64 -181.36,-12.2 -136.87,127.74 -30.65,-3.71 -36.39,-38.87 -45.67,-69.66 -0.67,-58.92 32.29,-75.05 36.51,-127.74 -13.47,-25.37 -19.64,-60.09 -54.79,-57.96 1.75,-44.18 67.47,-7.11 82.15,-34.83 12.8,-62.66 -24.63,-61.49 -27.36,-104.38 13.17,-60.6 49.56,-91.73 63.84,-150.87 30.99,-3.18 74.1,8.92 91.28,-11.66 10.44,-50.88 0,-38.02 -9.08,-81.24 -33.25,-3.49 -59.37,1.8 -82.2,11.69 -7.07,-63.28 14.04,-90.59 27.48,-127.74 -8.08,-32.26 -11.42,-70.61 -27.48,-92.9 15.57,-57.68 50.77,-90.05 45.69,-174 70.74,-72.19 97.2,-162.78 146.05,-278.53 9.77,-23.13 36.07,-34.61 45.59,-58.07 47.2,-115.38 26.72,-283.15 127.76,-336.45 -4.09,-71.02 26.07,-98.56 45.67,-139.28 26.3,5.27 28.54,41.06 63.87,34.9 105.91,-79.41 158.49,-419.28 54.79,-533.85 28.89,-25.26 53.77,-55.29 45.61,-127.62 -13.29,-27.9 -76.67,-33.33 -100.4,-11.66 7.87,-67.43 102.79,-23.98 118.64,-81.25 26.33,-1.39 59.71,6.38 73.01,-11.55 13,-86.23 -67.88,-53.01 -73.01,-116.03 -1.9,-48.88 32.24,-51.84 36.51,-92.94 42.84,-12.21 -15.02,39.19 18.31,46.41 37.13,-45.43 38.64,-136.42 36.48,-231.97 12.34,-23.06 31.8,-36.96 54.75,-46.52 -39.82,-43.96 8.45,-111.49 27.42,-150.91 174.58,189.11 346.69,-378.25 82.05,-255.21 4.68,110.43 -94.42,88.87 -91.26,197.25 -33.91,-3.27 -24.71,-61.34 -63.86,-57.97 -85.93,2.03 -144.64,202.83 -54.79,255.25 -22.47,29.22 -46.69,-50.85 -82.18,-11.59 -16.2,138.04 -80.91,214.26 -182.46,243.7 -86.06,-82.2 -140.68,112 -228.18,23.25 16.2,-14.23 36.97,-22.62 45.67,-46.49 -39.24,-88.69 -91.52,24.81 -155.15,11.66 -18.95,-2.98 -2.6,-50.97 -18.29,-58.07 -55.18,23.9 -132.34,35.34 -155.15,-34.72 -65.05,10.07 -50.34,121.57 -109.54,139.21 -82.66,0.73 -108.99,-70.32 -191.63,-69.56 0,26.95 0,54.04 0,81.1 -93.54,9.79 -30.82,-81.72 -18.22,-127.59 98.35,63.8 188.97,-61.7 118.56,-162.49 -21.19,0 -42.56,0 -63.87,0 73.98,-176.65 207.78,-277.5 301.2,-429.36 22.55,1.5 44,1.69 54.75,-11.59 7.69,-25.03 23.65,-39.55 18.31,-81.17 -80.74,-81.18 -101.06,26.21 -164.36,81.17 -23.18,20.2 -59.19,17.31 -82.15,34.76 -27.04,20.57 -34.56,62.54 -54.69,81.31 -36.3,33.77 -99.59,58.19 -127.76,92.8 -32.82,40.33 -46.91,102.25 -82.18,139.32 -98.5,103.32 -192.61,245.57 -237.3,440.95zm1213.78 406.14c-30.74,-7.33 -41.99,-39.41 -45.59,-81.14 19.34,-14.22 26.56,-43.73 54.75,-46.52 35.26,45.68 -9,66.18 -9.17,127.65zm-2089.86 2251.3c-13.7,18.37 -37.34,8.48 -45.67,-11.58 14.36,-1.06 7.18,-29.63 27.36,-23.25 -2.74,22.81 12.4,23.03 18.31,34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M10915.54 19557.57c1.08,29.51 13.27,44.95 36.48,46.41 7.36,607.32 666.17,421.63 657.18,-69.65 -2.03,-107.54 -44.61,-182.07 0,-313.33 -39.36,-11.33 -26.67,43.63 -54.87,46.41 -115.17,-107.86 -235.63,-244.62 -401.48,-162.45 -48.5,24.01 -75.4,87.47 -136.93,104.49 -24.17,108.49 -60.78,201.21 -72.98,324.87 4.27,24.74 -13.11,22.1 -27.39,23.24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSplashBlack1);
export default __webpack_public_path__ + "static/media/loaderSplashBlack1.99765ad0b3c5623784a461204d162987.svg";
export { ForwardRef as ReactComponent };